// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.paid-media-overview {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px 18px 0;
}

/*
 * Recharts positions the tooltip under the cursor. Without this the tooltip itself
 * swallows the pointer, so the chart never gets the \`mouseleave\` that would hide it and
 * the tooltip stays stuck until another click lands elsewhere.
 */
.paid-media-overview__chart-tooltip-wrapper {
  pointer-events: none;
}

/*
 * Visible keyboard focus for every interactive control in the dashboard.
 * Uses :focus-visible so pointer users do not see a ring on click.
 */
.paid-media-overview button:focus-visible,
.paid-media-overview a:focus-visible,
.paid-media-overview input:focus-visible,
.paid-media-overview select:focus-visible,
.paid-media-overview [role=tab]:focus-visible {
  outline: 2px solid #2b74e4;
  outline-offset: 2px;
  border-radius: 4px;
}

/**
 * Chart surfaces stay LTR so Recharts' absolute SVG coordinates and \`text-anchor\` keep working;
 * the mirroring is applied through props instead (see \`usePaidMediaChartRtl\`). The drawer chart is
 * portalled outside \`.paid-media-overview\`, so these are keyed on the chart wrappers rather than
 * on an ancestor.
 */
.paid-media-overview__chart .recharts-surface,
.paid-media-overview__investment-chart .recharts-surface,
.paid-media-overview__quadrant-chart .recharts-surface {
  direction: ltr;
}

/* ---------- Header ---------- */
.paid-media-overview__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px 20px;
  padding: 0 0 12px;
  margin: 0 0 12px;
  border-bottom: 1px solid #e4e7ec;
}

.paid-media-overview__header-copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
  text-align: start;
  max-width: 550px;
}

.paid-media-overview__title {
  margin: 0;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #101828;
}

.paid-media-overview__subtitle {
  margin: 0;
  max-width: 760px;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  color: #667085;
}

.paid-media-overview__header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  position: relative;
  margin-inline-start: auto;
  flex: 0 1 auto;
  min-width: 0;
}

.paid-media-overview__header-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: fit-content;
}

.paid-media-overview__header-row--bottom {
  width: fit-content;
  justify-content: flex-start;
  gap: 6px;
  align-items: center;
  flex-wrap: nowrap;
  overflow: visible;
}

/* ---------- Segmented control ---------- */
.paid-media-overview__segmented {
  display: inline-flex;
  padding: 2px;
  border-radius: 8px;
  background: #edf3fb;
  gap: 2px;
  align-self: flex-end;
  border: 0;
  margin: 0;
  min-width: 0;
}

.paid-media-overview__segmented--sm {
  font-size: 11px;
}

.paid-media-overview__segmented--md {
  font-size: 12px;
}

.paid-media-overview__segmented-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.paid-media-overview__segmented-btn {
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 14px 14px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: 0.01em;
  color: #64748b;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.paid-media-overview__segmented-btn:hover {
  color: #0f172a;
  background: rgba(255, 255, 255, 0.86);
}

/* Options the backend cannot serve yet stay visible but non-interactive. */
.paid-media-overview__segmented-btn:disabled,
.paid-media-overview__segmented-btn:disabled:hover {
  color: #94a3b8;
  background: transparent;
  cursor: not-allowed;
}

.paid-media-overview__segmented-btn--active {
  background: rgb(43, 104, 173);
  color: #ffffff;
  box-shadow: none;
}

.paid-media-overview__segmented-btn--active:hover {
  background: rgb(43, 104, 173);
  color: #ffffff;
  transform: none;
}

.paid-media-overview__date-range {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  border-radius: 8px;
  padding: 6px 10px;
  min-height: 36px;
  font-size: 12px;
  color: #64748b;
  width: fit-content;
  flex-wrap: nowrap;
}
.paid-media-overview__date-range input {
  border: 0;
  background: transparent;
  font-size: 12px;
  width: 96px;
  outline: none;
  color: #0f172a;
  padding: 0;
}

.paid-media-overview__more-filters {
  position: relative;
  overflow: visible;
}

.paid-media-overview__more-filters-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 14px;
  min-height: 48px;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.paid-media-overview__more-filters-trigger:hover {
  border-color: rgb(43, 104, 173);
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.14);
}

.paid-media-overview__segmented-option {
  position: relative;
}

.paid-media-overview__segmented-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.2s ease, visibility 0.2s ease;
}

.paid-media-overview__segmented-tooltip.is-visible {
  opacity: 1;
  visibility: visible;
}

.paid-media-overview__segmented-tooltip--end {
  left: auto;
  right: 0;
  transform: none;
}

.paid-media-overview__segmented-tooltip-card {
  min-width: 280px;
  max-width: min(320px, 100vw - 24px);
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
}

.paid-media-overview__segmented-tooltip-title {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  color: #0f172a;
}

.paid-media-overview__segmented-tooltip-description {
  font-size: 12px;
  line-height: 1.45;
  color: #475569;
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.paid-media-overview__more-filters-panel {
  position: absolute;
  inset-inline-end: 0;
  top: calc(100% + 6px);
  z-index: 20;
  width: 288px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Arabic: open toward the physical right so the panel stays inside the viewport. */
[dir=rtl] .paid-media-overview__header .paid-media-overview__segmented-tooltip--end {
  right: auto;
  left: 0;
}
[dir=rtl] .paid-media-overview__header .paid-media-overview__more-filters-panel {
  inset-inline-end: auto;
  inset-inline-start: auto;
  right: auto;
  left: 0;
}

/* Safety: the dashboard shell hides horizontal overflow; relax it while the panel is open in Arabic. */
[dir=rtl] .paid-media-dashboard:has(.paid-media-overview__more-filters--open) {
  overflow-x: visible;
}

.paid-media-overview__filter-label {
  display: block;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
}

.paid-media-overview__filter-label-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}
.paid-media-overview__filter-label-row .paid-media-overview__filter-label {
  margin-bottom: 0;
}

.paid-media-overview__filter-row--disabled .paid-media-overview__filter-label {
  color: #94a3b8;
}

.paid-media-overview__filter-select {
  width: 100%;
}
.paid-media-overview__filter-select .sales-product-analytics-dashboard__select-trigger {
  height: 34px;
  padding: 0 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  font-size: 12px;
  color: #1a1a1a;
}

.paid-media-overview__filter-select--disabled .sales-product-analytics-dashboard__select-trigger,
.paid-media-overview__filter-select--disabled .sales-product-analytics-dashboard__select-trigger--disabled {
  cursor: not-allowed;
  opacity: 0.55;
  background: #f8fafc;
  color: #64748b;
  border-color: #e2e8f0;
}

.paid-media-overview__filter-select-dropdown {
  max-height: min(240px, 100vh - 120px);
  overflow-y: auto;
  scrollbar-color: #cbd5e1 transparent;
  scrollbar-width: thin;
}
.paid-media-overview__filter-select-dropdown::-webkit-scrollbar {
  width: 6px;
}
.paid-media-overview__filter-select-dropdown::-webkit-scrollbar-track {
  background: transparent;
}
.paid-media-overview__filter-select-dropdown::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}

/* ---------- Partial-data warnings banner ---------- */
.paid-media-overview__warnings {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border: 1px solid rgba(255, 108, 0, 0.4);
  background: rgba(255, 108, 0, 0.08);
  border-radius: 6px;
  padding: 10px 12px;
}

.paid-media-overview__warnings-icon {
  display: inline-flex;
  color: #ff6c00;
  margin-top: 1px;
}

.paid-media-overview__warnings-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.paid-media-overview__warnings-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #ff6c00;
}

.paid-media-overview__warnings-list {
  margin: 0;
  padding-inline-start: 16px;
  font-size: 12px;
  line-height: 1.6;
  color: #1a1a1a;
}

/* ---------- KPI grid ---------- */
.paid-media-overview__kpi-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
}

.paid-media-overview__kpi-card {
  min-height: 140px;
}

.paid-media-overview__kpi-card.dashboard-kpi-card {
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);
  padding: 18px 20px;
  min-height: 168px;
}

.paid-media-overview__kpi-card .dashboard-kpi-card__title {
  color: #667085;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.01em;
  text-transform: none;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

.paid-media-overview__kpi-card .dashboard-kpi-card__value {
  color: #101828;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
  white-space: normal;
}

.paid-media-overview__kpi-card .dashboard-kpi-card__sublabel,
.paid-media-overview__kpi-card .dashboard-kpi-card__comparison,
.paid-media-overview__kpi-card .dashboard-kpi-card__footer,
.paid-media-overview__kpi-card .dashboard-kpi-card__description {
  color: #667085;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
}

.paid-media-overview__kpi-card .dashboard-kpi-card__change {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.paid-media-overview__kpi-card .dashboard-kpi-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #eef4ff;
  color: #2563eb;
}

.paid-media-overview__kpi-card .dashboard-kpi-card__icon svg {
  width: 22px;
  height: 22px;
}

.paid-media-overview__kpi-card .dashboard-kpi-card__title-row {
  margin-bottom: 20px;
}

@media (max-width: 1280px) {
  .paid-media-overview__kpi-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 1023px) {
  .paid-media-overview__header {
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .paid-media-overview__header-actions {
    margin-inline-start: 0;
    align-items: flex-end;
    width: 100%;
  }
  .paid-media-overview__header-row {
    justify-content: flex-end;
    width: 100%;
    flex-wrap: wrap;
  }
  .paid-media-overview__header-row--bottom {
    flex-wrap: wrap;
    width: 100%;
    justify-content: flex-end;
  }
}
@media (max-width: 639px) {
  .paid-media-overview__kpi-grid {
    grid-template-columns: 1fr;
  }
  .paid-media-overview__header {
    gap: 6px;
    padding: 0 0 2px;
  }
  .paid-media-overview__header-copy {
    gap: 2px;
  }
  .paid-media-overview__title {
    font-size: 24px;
  }
  .paid-media-overview__subtitle {
    font-size: 13px;
  }
  .paid-media-overview__header-actions {
    width: 100%;
    align-items: flex-end;
    gap: 6px;
    margin-inline-start: 0;
  }
  .paid-media-overview__header-row:not(.paid-media-overview__header-row--bottom) {
    width: 100%;
    max-width: 100%;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .paid-media-overview__header-row:not(.paid-media-overview__header-row--bottom)::-webkit-scrollbar {
    display: none;
  }
  .paid-media-overview__header-row--bottom {
    flex-direction: row;
    align-items: center;
    gap: 6px;
    width: 100%;
  }
  .paid-media-overview__segmented,
  .paid-media-overview__date-range,
  .paid-media-overview__more-filters-trigger {
    width: auto;
    max-width: none;
    justify-content: flex-end;
    flex-shrink: 0;
  }
  .paid-media-overview__segmented {
    display: inline-flex;
    min-width: fit-content;
  }
  .paid-media-overview__segmented-btn {
    padding: 7px 10px;
    font-size: 11px;
  }
  .paid-media-overview__date-range {
    flex-wrap: nowrap;
    padding: 6px 8px;
  }
  .paid-media-overview__date-range input {
    width: 84px;
    min-width: 0;
  }
  .paid-media-overview__more-filters-trigger {
    padding: 7px 10px;
  }
}
/* ---------- Shared panel bits ---------- */
.paid-media-overview__panel-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px 12px;
  margin-bottom: 12px;
  /* Lets the title column wrap instead of being squeezed by the legend. */
}
.paid-media-overview__panel-header h3 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.paid-media-overview__panel-header > div {
  min-width: 0;
}

/* The overview spaces its rows with grid \`gap\`, so the shared panel's own bottom
 * margin has to go — otherwise two panels in the same row end at different
 * heights (the margin is subtracted from the stretched item). */
.paid-media-overview__trend-grid > .paid-media-panel,
.paid-media-overview__two-col-grid > .paid-media-panel,
.paid-media-overview__comparison-grid > .paid-media-panel,
.paid-media-overview__insight-stack > .paid-media-panel {
  margin-bottom: 0;
}

.paid-media-overview__panel-subtitle {
  margin: 2px 0 0;
  font-size: 14px;
  color: #6b7280;
}

.paid-media-overview__panel-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.paid-media-overview__panel-header-note {
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
}

/* Four platform averages sit two per line so they cannot squeeze the title. */
.paid-media-overview__legend-inline {
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: end;
  gap: 2px 12px;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
  white-space: nowrap;
}

@media (max-width: 767px) {
  .paid-media-overview__legend-inline {
    justify-content: start;
  }
}
.paid-media-overview__chart-legend-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 8px 0 12px;
  padding: 0;
  background: transparent;
  border: 0;
}

.paid-media-overview__chart-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border-radius: 0;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: #475569;
  background: transparent;
}

.paid-media-overview__chart-legend-item--purple {
  color: #8d4fd3;
}

.paid-media-overview__chart-legend-item--green {
  color: #5abf8b;
}

.paid-media-overview__chart-legend-item--mint {
  color: #94d0b5;
}

.paid-media-overview__chart-legend-item--meta {
  color: #2b74e4;
}

.paid-media-overview__chart-legend-item--google {
  color: #f6c15f;
}

.paid-media-overview__chart-legend-item--meta-revenue {
  color: #5d97ee;
}

.paid-media-overview__chart-legend-item--google-revenue {
  color: #f0a84a;
}

.paid-media-overview__chart-legend-swatch {
  width: 20px;
  height: 14px;
  border-radius: 0;
  flex-shrink: 0;
}

.paid-media-overview__chart-legend-swatch--purple {
  background: #8d4fd3;
}

.paid-media-overview__chart-legend-swatch--green {
  background: #5abf8b;
}

.paid-media-overview__chart-legend-swatch--mint {
  background: #94d0b5;
}

.paid-media-overview__chart-legend-swatch--meta {
  background: #2b74e4;
}

.paid-media-overview__chart-legend-swatch--google {
  background: #f6c15f;
}

.paid-media-overview__chart-legend-swatch--meta-revenue {
  background: #5d97ee;
}

.paid-media-overview__chart-legend-swatch--google-revenue {
  background: #f0a84a;
}

.paid-media-overview__callout {
  margin-top: 12px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  color: #6b7280;
}
.paid-media-overview__callout strong {
  color: #1a1a1a;
}

.paid-media-overview__callout--success {
  border-color: #c9e5cf;
  background: #f0f8f2;
  color: #1a1a1a;
}
.paid-media-overview__callout--success strong {
  color: #28a745;
}

.paid-media-overview__text-success {
  color: #28a745;
}

.paid-media-overview__text-danger {
  color: #e53935;
}

.paid-media-overview__text-warning {
  color: #ff6c00;
}

/* Shown in place of a chart when the series has no rows. */
.paid-media-overview__chart-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 160px;
  padding: 16px;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}

/* ---------- Comparison cards ---------- */
.paid-media-overview__comparison-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

/* The two insight cards carry little content, so they keep their natural height
 * and sit centred in the column: the leftover height is split evenly above and
 * below the pair instead of leaving a gap between them. */
.paid-media-overview__insight-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  height: 100%;
}

.paid-media-overview__insight-stack .paid-media-overview__insight-card {
  flex: 1 1;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (max-width: 1279px) {
  .paid-media-overview__comparison-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 639px) {
  .paid-media-overview__comparison-grid {
    grid-template-columns: 1fr;
  }
}
.paid-media-overview__platform-card,
.paid-media-overview__insight-card {
  padding: 16px;
}

.paid-media-overview__platform-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.paid-media-overview__platform-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}
.paid-media-overview__platform-card-title span:last-child {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.paid-media-overview__platform-card-icon {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  color: #ffffff;
}

.paid-media-overview__platform-card-tag {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
}

.paid-media-overview__platform-card-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
  font-size: 12px;
}

.paid-media-overview__metric-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
}

.paid-media-overview__metric-value {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__platform-card-shares {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.paid-media-overview__insight-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.paid-media-overview__insight-card-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
}

.paid-media-overview__insight-card-icon {
  color: #9ca3af;
}

.paid-media-overview__insight-card-value {
  margin-top: 8px;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
}

.paid-media-overview__insight-card-copy {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: #6b7280;
}
.paid-media-overview__insight-card-copy strong {
  color: #1a1a1a;
}

.paid-media-overview__insight-card-callout {
  margin-top: 12px;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 600;
}

.paid-media-overview__insight-card-callout--positive {
  border: 1px solid #c9e5cf;
  background: #f0f8f2;
  color: #28a745;
}

.paid-media-overview__insight-card-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  margin-top: 12px;
  font-size: 11px;
  color: #6b7280;
}
.paid-media-overview__insight-card-legend strong {
  color: #1a1a1a;
}

/* ---------- Platform palette ----------
 * Slugs match \`OverviewPlatformDescriptor.slug\`; the fill colours match the
 * chart series colours in the same registry.
 */
/* Darkened for text and small dots, where the chart fill is too light to read. */
.paid-media-overview__share-bar-fill--meta-ads {
  background-color: #2b74e4;
}

.paid-media-overview__platform-dot-swatch--meta {
  background-color: #2b74e4;
}

.paid-media-overview__drawer-platform-tag--meta {
  background-color: #2b74e4;
}

.paid-media-overview__funnel[data-platform=meta] .paid-media-overview__funnel-dot,
.paid-media-overview__funnel[data-platform=meta] .paid-media-overview__funnel-bar {
  background-color: #2b74e4;
}

.paid-media-overview__share-bar-fill--google-ads {
  background-color: #f6c15f;
}

.paid-media-overview__platform-dot-swatch--google {
  background-color: #f6c15f;
}

.paid-media-overview__drawer-platform-tag--google {
  background-color: #f6c15f;
}

.paid-media-overview__funnel[data-platform=google] .paid-media-overview__funnel-dot,
.paid-media-overview__funnel[data-platform=google] .paid-media-overview__funnel-bar {
  background-color: #f6c15f;
}

.paid-media-overview__share-bar-fill--tiktok-ads {
  background-color: #ff3b5c;
}

.paid-media-overview__platform-dot-swatch--tiktok {
  background-color: #ff3b5c;
}

.paid-media-overview__drawer-platform-tag--tiktok {
  background-color: #ff3b5c;
}

.paid-media-overview__funnel[data-platform=tiktok] .paid-media-overview__funnel-dot,
.paid-media-overview__funnel[data-platform=tiktok] .paid-media-overview__funnel-bar {
  background-color: #ff3b5c;
}

.paid-media-overview__share-bar-fill--snapchat-ads {
  background-color: #0ea5a4;
}

.paid-media-overview__platform-dot-swatch--snapchat {
  background-color: #0ea5a4;
}

.paid-media-overview__drawer-platform-tag--snapchat {
  background-color: #0ea5a4;
}

.paid-media-overview__funnel[data-platform=snapchat] .paid-media-overview__funnel-dot,
.paid-media-overview__funnel[data-platform=snapchat] .paid-media-overview__funnel-bar {
  background-color: #0ea5a4;
}

.paid-media-overview__index-row-dot--meta {
  background-color: #2b74e4;
}

.paid-media-overview__legend-inline-item--meta {
  color: #2b74e4;
}

.paid-media-overview__chart-tooltip-heading--meta {
  color: #2b74e4;
}

.paid-media-overview__index-row-dot--google {
  background-color: #c18a2f;
}

.paid-media-overview__legend-inline-item--google {
  color: #c18a2f;
}

.paid-media-overview__chart-tooltip-heading--google {
  color: #c18a2f;
}

.paid-media-overview__index-row-dot--tiktok {
  background-color: #e11d48;
}

.paid-media-overview__legend-inline-item--tiktok {
  color: #e11d48;
}

.paid-media-overview__chart-tooltip-heading--tiktok {
  color: #e11d48;
}

.paid-media-overview__index-row-dot--snapchat {
  background-color: #0f766e;
}

.paid-media-overview__legend-inline-item--snapchat {
  color: #0f766e;
}

.paid-media-overview__chart-tooltip-heading--snapchat {
  color: #0f766e;
}

/* Card badges keep each network's own brand colour. */
.paid-media-overview__platform-card-icon--meta {
  background-color: #2b74e4;
}
.paid-media-overview__platform-card-icon--google {
  background-color: #f6c15f;
}
.paid-media-overview__platform-card-icon--tiktok {
  background-color: #010101;
}
.paid-media-overview__platform-card-icon--snapchat {
  background-color: #fffc00;
  color: #111827;
}

.paid-media-overview__platform-dot-swatch--unknown,
.paid-media-overview__drawer-platform-tag--unknown {
  background-color: #9ca3af;
}

/* ---------- Share bar ---------- */
.paid-media-overview__share-bar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  font-size: 12px;
}

.paid-media-overview__share-bar-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #6b7280;
}

.paid-media-overview__share-bar-value {
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__share-bar-track {
  height: 8px;
  width: 100%;
  overflow: hidden;
  border-radius: 999px;
  background: #e5e7eb;
}

.paid-media-overview__share-bar-fill {
  height: 100%;
  border-radius: 999px;
  /* Live percentage supplied by OverviewShareBar; 0% until it is set. */
  width: var(--paid-media-share-bar-value, 0%);
}

/* ---------- Status badge / platform dot ---------- */
.paid-media-overview__status-badge {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 6px;
  border: 1px solid;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
}

.paid-media-overview__status-badge .definition-tooltip {
  position: absolute;
  inset: 0;
  display: block;
}

.paid-media-overview__status-badge .definition-tooltip__trigger {
  display: block;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  opacity: 0;
  cursor: help;
}

.paid-media-overview__platform-dot {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.paid-media-overview__platform-dot-swatch {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

/*
 * Status badge palette. Modifier slugs are produced by \`overviewStatusModifier\`,
 * so the badge component ships class names only and carries no inline styles.
 */
.paid-media-overview__status-badge--scale-winner {
  color: #28a745;
  border-color: #28a745;
  background-color: rgba(40, 167, 69, 0.07);
}

.paid-media-overview__status-badge--efficiency-winner {
  color: #2b74e4;
  border-color: #2b74e4;
  background-color: rgba(43, 116, 228, 0.07);
}

.paid-media-overview__status-badge--growth-opportunity {
  color: #8d4fd3;
  border-color: #8d4fd3;
  background-color: rgba(141, 79, 211, 0.07);
}

.paid-media-overview__status-badge--stable {
  color: #6b7280;
  border-color: #6b7280;
  background-color: rgba(107, 114, 128, 0.07);
}

.paid-media-overview__status-badge--high-spend-low-return {
  color: #e53935;
  border-color: #e53935;
  background-color: rgba(229, 57, 53, 0.07);
}

.paid-media-overview__status-badge--needs-review {
  color: #ff6c00;
  border-color: #ff6c00;
  background-color: rgba(255, 108, 0, 0.07);
}

.paid-media-overview__status-badge--low-priority {
  color: #6b7280;
  border-color: #6b7280;
  background-color: rgba(107, 114, 128, 0.07);
}

.paid-media-overview__status-badge--unknown {
  color: #6b7280;
  border-color: #6b7280;
  background-color: rgba(107, 114, 128, 0.07);
}

/* ---------- Trend + contribution row ---------- */
.paid-media-overview__trend-grid {
  display: grid;
  grid-template-columns: minmax(0, 7fr) minmax(280px, 3fr);
  gap: 12px;
}

@media (max-width: 1279px) {
  .paid-media-overview__trend-grid {
    grid-template-columns: 1fr;
  }
}
.paid-media-overview__trend-metric-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 12px;
}

.paid-media-overview__trend-metric-tab {
  display: flex;
  align-items: center;
}

.paid-media-overview__trend-metric-btn {
  position: relative;
  border: 0;
  background: transparent;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.paid-media-overview__trend-metric-btn:hover {
  color: #1a1a1a;
}

.paid-media-overview__trend-metric-btn--active {
  color: #2b74e4;
}
.paid-media-overview__trend-metric-btn--active::after {
  content: "";
  position: absolute;
  left: 4px;
  right: 4px;
  bottom: -1px;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: #2b74e4;
}

.paid-media-overview__chart {
  width: 100%;
}

.paid-media-overview__chart--trend {
  height: 320px;
}

.paid-media-overview__chart--md {
  height: 280px;
}

.paid-media-overview__chart--sm {
  height: 260px;
}

.paid-media-overview__chart-tooltip {
  border: 1px solid #e5e7eb;
  border-inline-start: 4px solid #2b74e4;
  background: #ffffff;
  border-radius: 12px;
  padding: 10px 14px 10px 12px;
  font-size: 11px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);
}

.paid-media-overview__chart-tooltip-title {
  margin-bottom: 8px;
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__chart-tooltip-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px 16px;
}

.paid-media-overview__chart-tooltip-columns--quad {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (max-width: 1023px) {
  .paid-media-overview__chart-tooltip-columns--quad {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.paid-media-overview__chart-tooltip-heading {
  margin-bottom: 2px;
  font-weight: 600;
}

.paid-media-overview__chart-tooltip-footer {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #e5e7eb;
  color: #6b7280;
}
.paid-media-overview__chart-tooltip-footer strong {
  color: #1a1a1a;
}

.paid-media-overview__contribution-rows {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px 24px;
}

@media (max-width: 1023px) {
  .paid-media-overview__contribution-rows {
    grid-template-columns: 1fr;
  }
}
.paid-media-overview__contribution-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.paid-media-overview__contribution-row-title {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
}

/* ---------- Two-column rows ---------- */
.paid-media-overview__two-col-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 1023px) {
  .paid-media-overview__two-col-grid {
    grid-template-columns: 1fr;
  }
}
/* ---------- Funnel ---------- */
.paid-media-overview__funnel-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px 24px;
}

@media (max-width: 1279px) {
  .paid-media-overview__funnel-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 639px) {
  .paid-media-overview__funnel-grid {
    grid-template-columns: 1fr;
  }
}
.paid-media-overview__funnel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__funnel-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
}

.paid-media-overview__funnel-stages {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.paid-media-overview__funnel-stage-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  color: #6b7280;
  padding-bottom: 5px;
}
.paid-media-overview__funnel-stage-row span:first-child {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.paid-media-overview__funnel-stage-value {
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__funnel-bar {
  height: 24px;
  border-radius: 6px;
  opacity: 0.85;
}

.paid-media-overview__funnel-footer {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 6px;
  padding: 8px;
  font-size: 11px;
}

.paid-media-overview__funnel-footer-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-transform: uppercase;
  color: #6b7280;
}

.paid-media-overview__funnel-footer-value {
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__funnel-bar-progress-bar-center {
  justify-content: center;
  display: flex;
}

.paid-media-overview__funnel-bar[data-width=full] {
  width: 100%;
}
.paid-media-overview__funnel-bar[data-width=mid] {
  width: 68%;
}
.paid-media-overview__funnel-bar[data-width=low] {
  width: 32%;
}

/* ---------- Investment efficiency ---------- */
.paid-media-overview__investment-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);
  gap: 16px;
}

@media (max-width: 1023px) {
  .paid-media-overview__investment-grid {
    grid-template-columns: 1fr;
  }
}
.paid-media-overview__index-panel {
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 6px;
  padding: 12px;
}

.paid-media-overview__index-panel-title {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
}

.paid-media-overview__index-panel-subtitle {
  margin-top: 4px;
  font-size: 10px;
  color: #6b7280;
}

.paid-media-overview__index-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.paid-media-overview__index-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 6px;
  padding: 6px 8px;
}

.paid-media-overview__index-row-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__index-row-value {
  font-size: 14px;
  font-weight: 700;
}

.paid-media-overview__index-panel-footnote {
  margin-top: 12px;
  font-size: 11px;
  color: #6b7280;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.paid-media-overview__index-row-dot--meta {
  background-color: #2b74e4;
}
.paid-media-overview__index-row-dot--google {
  background-color: #c18a2f;
}

.paid-media-overview__share-bar--spend path {
  fill: #2b74e4;
}
.paid-media-overview__share-bar--revenue path {
  fill: #8d4fd3;
}

.paid-media-overview__share-bar-label {
  font-size: 11px;
  fill: #1a1a1a;
  font-weight: 600;
}

/* ---------- Quadrant chart ---------- */
.paid-media-overview__quadrant-chart {
  position: relative;
  height: 360px;
  width: 100%;
}

.paid-media-overview__quadrant-labels {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #9ca3af;
}

.paid-media-overview__quadrant-label {
  position: absolute;
}

/*
 * The \`tl\`/\`tr\`/\`bl\`/\`br\` modifiers name the quadrant in reading order, not in physical sides:
 * the scatter's spend axis counts from the inline start, so in Arabic it counts from the right and
 * these labels have to follow it. Insets are logical for that reason — the wider start inset also
 * clears the value axis, which moves to the right edge with the axis (see \`usePaidMediaChartRtl\`).
 */
.paid-media-overview__quadrant-label--tl {
  inset-inline-start: 56px;
  top: -8px;
}

.paid-media-overview__quadrant-label--tr {
  inset-inline-end: 16px;
  top: -8px;
}

.paid-media-overview__quadrant-label--bl {
  inset-inline-start: 56px;
  bottom: 18px;
}

.paid-media-overview__quadrant-label--br {
  inset-inline-end: 16px;
  bottom: 18px;
}

.paid-media-overview__quadrant-tooltip {
  max-width: 260px;
  border: 1px solid #e5e7eb;
  border-inline-start: 4px solid #2b74e4;
  background: #ffffff;
  border-radius: 12px;
  padding: 10px 14px 10px 12px;
  font-size: 11px;
  line-height: 1.6;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);
}

.paid-media-overview__quadrant-tooltip-title {
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__quadrant-tooltip-body {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #1a1a1a;
}

.paid-media-overview__quadrant-tooltip-classification {
  margin-top: 6px;
  font-weight: 600;
  color: #2b74e4;
}

.paid-media-overview__quadrant-tooltip-reason {
  margin-top: 4px;
  color: #6b7280;
}

.paid-media-overview__quadrant-tooltip-hint {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #e5e7eb;
  color: #2b74e4;
  font-weight: 500;
}

/* ---------- Revenue validation ---------- */
.paid-media-overview__variance-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-top: 12px;
  font-size: 12px;
}

.paid-media-overview__variance-box {
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 6px;
  padding: 8px;
}

.paid-media-overview__variance-box-title {
  font-size: 11px;
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__variance-box-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 4px;
}

.paid-media-overview__variance-box-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  text-transform: uppercase;
  color: #6b7280;
}

.paid-media-overview__variance-box-value {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
}

/* Shown in place of the store columns when no store is connected. */
.paid-media-overview__confidence-footnote {
  margin-top: 16px;
  font-size: 11px;
  line-height: 1.6;
  color: #6b7280;
}

/* ---------- Attribution confidence ---------- */
.paid-media-overview__confidence-score {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 20px 16px;
  margin-bottom: 20px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f8fafc;
  text-align: center;
}

.paid-media-overview__confidence-score-value {
  font-size: 34px;
  font-weight: 700;
  line-height: 1.1;
  color: #16a34a;
}

.paid-media-overview__confidence-score-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #16a34a;
}

.paid-media-overview__confidence-components {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.paid-media-overview-platform-and-store {
  margin: 5px 10px 5px 0 !important;
}

.paid-media-daily-spend-revenue-trend {
  margin: 5px 10px 5px -10 !important;
}

.platform-reported-bar {
  fill: #8d4fd3 !important;
}

.store-gross-bar {
  fill: #5abf8b !important;
}

.store-net-bar {
  fill: #94d0b5 !important;
}

.paid-media-overview__share-bar-fill {
  height: 100%;
  border-radius: 999px;
}
.paid-media-overview__share-bar-fill--confidence-green {
  background-color: #5abf8b;
}
.paid-media-overview__share-bar-fill--confidence-blue {
  background-color: #2b74e4;
}
.paid-media-overview__share-bar-fill--confidence-purple {
  background-color: #8d4fd3;
}
.paid-media-overview__share-bar-fill--confidence-orange {
  background-color: #f6c15f;
}

.benchmark-reference-label {
  fill: #8d4fd3;
  font-size: 14px;
  font-weight: 500;
}

/* ---------- Campaign leaderboard ---------- */
.paid-media-overview__leaderboard {
  padding: 0;
  overflow: hidden;
}
.paid-media-overview__leaderboard table {
  width: max-content;
  min-width: 100%;
  table-layout: auto;
}
.paid-media-overview__leaderboard table,
.paid-media-overview__leaderboard th,
.paid-media-overview__leaderboard td {
  white-space: nowrap;
}
.paid-media-overview__leaderboard th,
.paid-media-overview__leaderboard td {
  overflow: hidden;
  text-overflow: ellipsis;
}
.paid-media-overview__leaderboard th:last-child,
.paid-media-overview__leaderboard td:last-child {
  width: 1%;
  white-space: nowrap;
}

.paid-media-overview__leaderboard-header {
  padding: 16px;
}

.paid-media-overview__leaderboard-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: end;
  gap: 12px;
}

.paid-media-overview__leaderboard-platform-tabs {
  display: flex;
  gap: 2px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 6px;
  padding: 2px;
}

.paid-media-overview__export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  cursor: pointer;
}
.paid-media-overview__export-btn:hover:not(:disabled) {
  border-color: #2b74e4;
}
.paid-media-overview__export-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.paid-media-overview__leaderboard-th {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.paid-media-overview__leaderboard-th--right {
  justify-content: flex-end;
}

.paid-media-overview__leaderboard-cell--right {
  text-align: end;
}

.paid-media-overview__leaderboard-cell--strong {
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__leaderboard-cell--status {
  white-space: nowrap;
}

.paid-media-overview__leaderboard-row-link {
  display: inline-block;
  max-width: 100%;
  border: 0;
  background: transparent;
  padding: 0;
  font: inherit;
  font-weight: 600;
  color: #1a1a1a;
  cursor: pointer;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.paid-media-overview__leaderboard-row-link:hover {
  color: #2b74e4;
  text-decoration: underline;
}

.paid-media-overview__cell-strong {
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__leaderboard .definition-tooltip__popover {
  overflow: hidden;
  overflow-wrap: anywhere;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.paid-media-overview__leaderboard .definition-tooltip__popover::-webkit-scrollbar {
  display: none;
}

.paid-media-overview__leaderboard .definition-tooltip__text,
.paid-media-overview__leaderboard .definition-tooltip__formula,
.paid-media-overview__leaderboard .definition-tooltip__note {
  margin: 0;
  line-height: 1.5;
  white-space: normal;
}

.paid-media-overview__leaderboard .definition-tooltip__formula-box {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 8px;
}

.paid-media-overview__leaderboard-empty {
  margin: 0;
  padding: 32px 16px;
  font-size: 13px;
  color: #6b7280;
  text-align: center;
}

@media (min-width: 965px) and (max-width: 1333px) {
  .paid-media-overview__leaderboard-filters {
    justify-content: end;
  }
}
/* ---------- Drawer ---------- */
.paid-media-overview__drawer-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ant-drawer-right .ant-drawer-header .ant-drawer-header-title {
  flex-direction: row-reverse;
}

.paid-media-overview__drawer-subtitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
}

.paid-media-overview__drawer-platform-tag {
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
}

.paid-media-overview__drawer-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.paid-media-overview__campaign-drawer {
  /* Chart no longer has a fixed height: it fills the card and never pushes it. */
}
.paid-media-overview__campaign-drawer .ant-drawer-body {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.paid-media-overview__campaign-drawer .paid-media-overview__drawer-body {
  flex: 1 1;
  min-height: 0;
}
.paid-media-overview__campaign-drawer .paid-media-overview__drawer-chart-card {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.paid-media-overview__campaign-drawer .paid-media-overview__chart--sm {
  flex: 1 1;
  height: auto;
  min-height: 180px;
  min-width: 0;
}

.paid-media-overview__drawer-kpi-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.paid-media-overview__mini-kpi {
  border: 1px solid #e5e7eb;
  background: #f8fafc;
  border-radius: 6px;
  padding: 8px;
}

.paid-media-overview__mini-kpi-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
}

.paid-media-overview__mini-kpi-value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
}

.paid-media-overview__drawer-chart-card {
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 10px;
  padding: 12px;
}

.paid-media-overview__drawer-chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
}

.paid-media-overview__drawer-insight {
  border: 1px solid #bfd4f2;
  background: #eaf2fd;
  border-radius: 6px;
  padding: 12px;
  font-size: 12px;
  line-height: 1.6;
  color: #1a1a1a;
}
.paid-media-overview__drawer-insight strong {
  color: #2b74e4;
}

.paid-media-overview__drawer-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
}

.paid-media-overview__drawer-close {
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  cursor: pointer;
}
.paid-media-overview__drawer-close:hover {
  border-color: #2b74e4;
}

/* Search box */
.paid-media-overview__leaderboard-search {
  height: 48px;
  min-width: 220px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  background: #ffffff;
  border: 1px solid #e2e2e6;
  border-radius: 10px;
  box-sizing: border-box;
}

.paid-media-overview__leaderboard-search:hover,
.paid-media-overview__leaderboard-search:focus-within {
  border-color: #2b74e4;
}

.paid-media-overview__leaderboard-search .paid-media-overview__leaderboard-search-input,
.paid-media-overview__leaderboard-search input {
  border: none;
  border-radius: 0;
  outline: none;
  padding: 0;
  font-size: 14px;
  color: #1a1a1a;
  background: transparent;
  width: 100%;
}

.paid-media-overview__leaderboard-search input::placeholder {
  color: #9a9a9f;
}

/* Dropdowns */
.paid-media-overview__leaderboard-filter-dropdown {
  height: 48px;
  box-sizing: border-box;
}

.paid-media-overview__leaderboard-filter-dropdown .ant-select-selector,
.paid-media-overview__leaderboard-filter-dropdown.ant-select .ant-select-selector {
  height: 38px !important;
  border-radius: 10px !important;
  padding: 0 14px !important;
  display: flex;
  align-items: center;
  background-color: #ffffff !important;
  border: 1px solid #e2e2e6 !important;
  box-sizing: border-box;
}

.paid-media-overview__leaderboard-filter-dropdown .ant-select-selection-item {
  font-size: 14px;
  line-height: 36px;
  color: #2b74e4;
  font-weight: 500;
}

.paid-media-overview__leaderboard-filter-dropdown:hover .ant-select-selector {
  border-color: #2b74e4 !important;
  background-color: #ffffff !important;
}

.paid-media-overview__leaderboard-filter-dropdown.ant-select-focused .ant-select-selector,
.paid-media-overview__leaderboard-filter-dropdown.ant-select-open .ant-select-selector {
  border-color: #2b74e4 !important;
  background-color: #ffffff !important;
  box-shadow: 0 0 0 2px rgba(43, 116, 228, 0.12) !important;
}

/* ---------- Level tabs (Campaigns / Ad sets / Ads) ---------- */
.paid-media-overview__level-tabs {
  align-items: center;
  gap: 4px;
  width: 100%;
  background: #eef1f6;
  border-radius: 12px;
  padding: 6px;
  margin-bottom: 12px;
}

.paid-media-overview__level-tab {
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}
.paid-media-overview__level-tab:hover {
  color: #1a1a2e;
}

.paid-media-overview__level-tab--active {
  background: #ffffff;
  color: #1a1a2e;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

.paid-media-overview__leaderboard-toprow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.paid-media-overview__panel-header-titles {
  min-width: 0;
}
.paid-media-overview__panel-header-titles h3 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #101828;
}

.paid-media-overview__export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 48px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  cursor: pointer;
  box-sizing: border-box;
  flex-shrink: 0;
}
.paid-media-overview__export-btn:hover {
  border-color: #2b74e4;
}

.campaign-leaderboard-article {
  padding: 0px 0px !important;
}

.paid-media-overview__leaderboard-table-wrap .dashboard-data-table-card {
  border: 0;
  border-top: 1px solid #e5e5e5;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
}

.paid-media-overview__granularity-segmented .paid-media-overview__segmented {
  border-color: #d0d5dd;
  background: #eef1f6;
}
.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn {
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  min-width: 48px;
  height: 28px;
  padding: 0 12px;
  cursor: pointer;
}
.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn:hover {
  background: #eef1f6;
}
.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn--active {
  background: #ffffff;
  color: #000000;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}
.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn--active:hover {
  background: white;
}`, "",{"version":3,"sources":["webpack://./src/dashboards/paidMedia/components/overview/PaidMediaOverviewDashboard.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_base.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_header.scss","webpack://./src/styles/_variables.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_warnings.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_kpi.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_panels.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_comparison.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_platforms.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_share-bar.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_badges.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_trend.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_funnel.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_investment.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_quadrant.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_attribution.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_leaderboard.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_drawer.scss","webpack://./src/dashboards/paidMedia/components/overview/styles/_level-tabs.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;ADEF;;ACCA;;;;EAAA;AAKA;EACE,oBAAA;ADEF;;ACCA;;;EAAA;AAKE;;;;;EAKE,0BAAA;EACA,mBAAA;EACA,kBAAA;ADCJ;;ACGA;;;;;EAAA;AASE;;;EACE,cAAA;ADDJ;;AEzCA,iCAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;AF4CF;;AEzCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,uBAAA;EACA,iBAAA;EACA,gBAAA;AF2CF;;AExCA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AF2CF;;AExCA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AF2CF;;AExCA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;AF2CF;;AExCA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,kBAAA;AF2CF;;AExCA;EACE,kBAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AF2CF;;AExCA,4CAAA;AACA;EACE,oBAAA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AF2CJ;;AExCA;EACE,eAAA;AF2CF;;AExCA;EACE,eAAA;AF2CF;;AExCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AF2CF;;AExCA;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,uDAAA;AF2CF;;AExCA;EACE,cAAA;EACA,qCAAA;AF2CF;;AExCA,2EAAA;AACA;;EAEE,cAAA;EACA,uBAAA;EACA,mBAAA;AF2CF;;AExCA;EACE,6BCoHkB;EDnHlB,cAAA;EACA,gBAAA;AF2CF;;AExCA;EACE,6BC8GkB;ED7GlB,cAAA;EACA,eAAA;AF2CF;;AExCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AF2CF;AEzCE;EACE,SAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;AF2CJ;;AEvCA;EACE,kBAAA;EACA,iBAAA;AF0CF;;AEvCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AF0CF;AExCE;EACE,+BC2DgB;ED1DhB,6CAAA;AF0CJ;;AEtCA;EACE,kBAAA;AFyCF;;AEtCA;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,mDAAA;AFyCF;;AEtCA;EACE,UAAA;EACA,mBAAA;AFyCF;;AEtCA;EACE,UAAA;EACA,QAAA;EACA,eAAA;AFyCF;;AEtCA;EACE,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;AFyCF;;AEtCA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AFyCF;;AEtCA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,wFAAA;AFyCF;;AEtCA;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCC1DU;ED2DV,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AFyCF;;AEtCA,mFAAA;AAEE;EACE,WAAA;EACA,OAAA;AFwCJ;AErCE;EACE,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,OAAA;AFuCJ;;AEnCA,uGAAA;AACA;EACE,mBAAA;AFsCF;;AEnCA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cCrDkB;AH2FpB;;AEnCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AFsCF;AEpCE;EACE,gBAAA;AFsCJ;;AEjCE;EACE,cAAA;AFoCJ;;AEhCA;EACE,WAAA;AFmCF;AEjCE;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cCpFM;AHuHV;;AE9BE;;EAEE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AFiCJ;;AE7BA;EACE,qCAAA;EACA,gBAAA;EACA,oCAAA;EACA,qBAAA;AFgCF;AE9BE;EACE,UAAA;AFgCJ;AE7BE;EACE,uBAAA;AF+BJ;AE5BE;EACE,oBAAA;EACA,mBAAA;AF8BJ;;AIrXA,uDAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,wCAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;AJwXF;;AIrXA;EACE,oBAAA;EACA,cD+NW;EC9NX,eAAA;AJwXF;;AIrXA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AJwXF;;AIrXA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD+MW;AHyKb;;AIrXA;EACE,SAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,cD+LQ;AHyLV;;AK7ZA,mCAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;ALgaF;;AK7ZA;EACE,iBAAA;ALgaF;;AK7ZA;EACE,yBAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;ALgaF;;AK7ZA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;ALgaF;;AK7ZA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;ALgaF;;AK7ZA;;;;EAIE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ALgaF;;AK7ZA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ALgaF;;AK7ZA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;ALgaF;;AK7ZA;EACE,WAAA;EACA,YAAA;ALgaF;;AK7ZA;EACE,mBAAA;ALgaF;;AK5ZA;EACE;IACE,gDAAA;EL+ZF;AACF;AK5ZA;EACE;IACE,sBAAA;IACA,oBAAA;IACA,oBAAA;IACA,mBAAA;EL8ZF;EK3ZA;IACE,sBAAA;IACA,qBAAA;IACA,WAAA;EL6ZF;EK1ZA;IACE,yBAAA;IACA,WAAA;IACA,eAAA;EL4ZF;EKzZA;IACE,eAAA;IACA,WAAA;IACA,yBAAA;EL2ZF;AACF;AKxZA;EACE;IACE,0BAAA;EL0ZF;EKvZA;IACE,QAAA;IACA,gBAAA;ELyZF;EKtZA;IACE,QAAA;ELwZF;EKrZA;IACE,eAAA;ELuZF;EKpZA;IACE,eAAA;ELsZF;EKnZA;IACE,WAAA;IACA,qBAAA;IACA,QAAA;IACA,sBAAA;ELqZF;EKlZA;IACE,WAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;IACA,mBAAA;IACA,yBAAA;IACA,gBAAA;IACA,kBAAA;IACA,qBAAA;IACA,wBAAA;ELoZF;EKjZA;IACE,aAAA;ELmZF;EKhZA;IACE,mBAAA;IACA,mBAAA;IACA,QAAA;IACA,WAAA;ELkZF;EK/YA;;;IAGE,WAAA;IACA,eAAA;IACA,yBAAA;IACA,cAAA;ELiZF;EK9YA;IACE,oBAAA;IACA,sBAAA;ELgZF;EK7YA;IACE,iBAAA;IACA,eAAA;EL+YF;EK5YA;IACE,iBAAA;IACA,gBAAA;EL8YF;EK3YA;IACE,WAAA;IACA,YAAA;EL6YF;EK1YA;IACE,iBAAA;EL4YF;AACF;AM3kBA,4CAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EAYA,wEAAA;ANkkBF;AM5kBE;EACE,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cHoNM;AH0XV;AM1kBE;EACE,YAAA;AN4kBJ;;AMxkBA;;gEAAA;AAGA;;;;EAIE,gBAAA;AN2kBF;;AMxkBA;EACE,eAAA;EACA,eAAA;EACA,cH+LkB;AH4YpB;;AMxkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AN2kBF;;AMxkBA;EACE,eAAA;EACA,gBAAA;EACA,cHiLQ;EGhLR,mBAAA;AN2kBF;;AMxkBA,8EAAA;AACA;EACE,aAAA;EACA,sCAAA;EACA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AN2kBF;;AMxkBA;EACE;IACE,sBAAA;EN2kBF;AACF;AMxkBA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,SAAA;AN0kBF;;AMvkBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AN0kBF;;AMvkBA;EACE,cAAA;AN0kBF;;AMvkBA;EACE,cAAA;AN0kBF;;AMvkBA;EACE,cAAA;AN0kBF;;AMvkBA;EACE,cAAA;AN0kBF;;AMvkBA;EACE,cAAA;AN0kBF;;AMvkBA;EACE,cAAA;AN0kBF;;AMvkBA;EACE,cAAA;AN0kBF;;AMvkBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AN0kBF;;AMvkBA;EACE,mBAAA;AN0kBF;;AMvkBA;EACE,mBAAA;AN0kBF;;AMvkBA;EACE,mBAAA;AN0kBF;;AMvkBA;EACE,mBAAA;AN0kBF;;AMvkBA;EACE,mBAAA;AN0kBF;;AMvkBA;EACE,mBAAA;AN0kBF;;AMvkBA;EACE,mBAAA;AN0kBF;;AMvkBA;EACE,gBAAA;EACA,yBAAA;EACA,mBHqEY;EGpEZ,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cH6DkB;AH6gBpB;AMxkBE;EACE,cHyDM;AHihBV;;AMtkBA;EACE,qBAAA;EACA,mBAAA;EACA,cHkDQ;AHuhBV;AMvkBE;EACE,cHqDS;AHohBb;;AMrkBA;EACE,cHgDW;AHwhBb;;AMrkBA;EACE,cH6CU;AH2hBZ;;AMrkBA;EACE,cH0CW;AH8hBb;;AMrkBA,2DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBH0BY;EGzBZ,eAAA;EACA,cHoBkB;EGnBlB,kBAAA;ANwkBF;;AO1xBA,2CAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AP6xBF;;AO1xBA;;0DAAA;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;AP6xBF;;AOvxBA;EACE,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AP0xBF;;AOvxBA;EACE;IACE,gDAAA;EP0xBF;AACF;AOvxBA;EACE;IACE,0BAAA;EPyxBF;AACF;AOtxBA;;EAEE,aAAA;APwxBF;;AOrxBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;APwxBF;;AOrxBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cJyKQ;AH+mBV;AOtxBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;APwxBJ;;AOpxBA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;APuxBF;;AOpxBA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cJmJkB;AHooBpB;;AOpxBA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;EACA,eAAA;APuxBF;;AOpxBA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cJqIkB;AHkpBpB;;AOpxBA;EACE,eAAA;EACA,gBAAA;EACA,cJ8HQ;AHypBV;;AOpxBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;APuxBF;;AOpxBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;APuxBF;;AOpxBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cJuGkB;AHgrBpB;;AOpxBA;EACE,cJoGc;AHmrBhB;;AOpxBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cJ2FQ;AH4rBV;;AOpxBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cJqFkB;AHksBpB;AOrxBE;EACE,cJiFM;AHssBV;;AOnxBA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;APsxBF;;AOnxBA;EACE,yBAAA;EACA,mBAAA;EACA,cJwEW;AH8sBb;;AOnxBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cJyDkB;AH6tBpB;AOpxBE;EACE,cJqDM;AHiuBV;;AQr8BA;;;EAAA;AAWA,iFAAA;AASE;EACE,yBAjBwB;AR08B5B;;AQt7BE;EACE,yBArBwB;AR88B5B;;AQt7BE;EACE,yBAzBwB;ARk9B5B;;AQr7BI;;EAEE,yBA/BsB;ARu9B5B;;AQv8BE;EACE,yBAjBwB;AR29B5B;;AQv8BE;EACE,yBArBwB;AR+9B5B;;AQv8BE;EACE,yBAzBwB;ARm+B5B;;AQt8BI;;EAEE,yBA/BsB;ARw+B5B;;AQx9BE;EACE,yBAjBwB;AR4+B5B;;AQx9BE;EACE,yBArBwB;ARg/B5B;;AQx9BE;EACE,yBAzBwB;ARo/B5B;;AQv9BI;;EAEE,yBA/BsB;ARy/B5B;;AQz+BE;EACE,yBAjBwB;AR6/B5B;;AQz+BE;EACE,yBArBwB;ARigC5B;;AQz+BE;EACE,yBAzBwB;ARqgC5B;;AQx+BI;;EAEE,yBA/BsB;AR0gC5B;;AQr+BE;EACE,yBA9BuB;ARsgC3B;;AQr+BE;EACE,cAlCuB;AR0gC3B;;AQr+BE;EACE,cAtCuB;AR8gC3B;;AQj/BE;EACE,yBA9BuB;ARkhC3B;;AQj/BE;EACE,cAlCuB;ARshC3B;;AQj/BE;EACE,cAtCuB;AR0hC3B;;AQ7/BE;EACE,yBA9BuB;AR8hC3B;;AQ7/BE;EACE,cAlCuB;ARkiC3B;;AQ7/BE;EACE,cAtCuB;ARsiC3B;;AQzgCE;EACE,yBA9BuB;AR0iC3B;;AQzgCE;EACE,cAlCuB;AR8iC3B;;AQzgCE;EACE,cAtCuB;ARkjC3B;;AQxgCA,sDAAA;AAEE;EACE,yBAAA;AR0gCJ;AQvgCE;EACE,yBAAA;ARygCJ;AQtgCE;EACE,yBAAA;ARwgCJ;AQrgCE;EACE,yBAAA;EACA,cAAA;ARugCJ;;AQngCA;;EAEE,yBL0Jc;AH42BhB;;ASllCA,oCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;ATqlCF;;ASllCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cNwNkB;AH63BpB;;ASllCA;EACE,gBAAA;EACA,cNkNQ;AHm4BV;;ASllCA;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBN6MU;AHw4BZ;;ASllCA;EACE,YAAA;EACA,oBAAA;EACA,sEAAA;EACA,4CAAA;ATqlCF;;AUtnCA,sDAAA;AACA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AVynCF;;AUtnCA;EACE,kBAAA;EACA,QAAA;EACA,cAAA;AVynCF;;AUtnCA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AVynCF;;AUtnCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cP4LQ;EO3LR,mBAAA;EACA,gBAAA;EACA,uBAAA;AVynCF;;AUtnCA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;AVynCF;;AUrnCA;;;EAAA;AAgBE;EACE,cAbuB;EAcvB,qBAduB;EAevB,yCAAA;AV4mCJ;;AU/mCE;EACE,cAbuB;EAcvB,qBAduB;EAevB,0CAAA;AVknCJ;;AUrnCE;EACE,cAbuB;EAcvB,qBAduB;EAevB,0CAAA;AVwnCJ;;AU3nCE;EACE,cAbuB;EAcvB,qBAduB;EAevB,2CAAA;AV8nCJ;;AUjoCE;EACE,cAbuB;EAcvB,qBAduB;EAevB,yCAAA;AVooCJ;;AUvoCE;EACE,cAbuB;EAcvB,qBAduB;EAevB,yCAAA;AV0oCJ;;AU7oCE;EACE,cAbuB;EAcvB,qBAduB;EAevB,2CAAA;AVgpCJ;;AUnpCE;EACE,cAbuB;EAcvB,qBAduB;EAevB,2CAAA;AVspCJ;;AW9tCA,mDAAA;AACA;EACE,aAAA;EACA,wDAAA;EACA,SAAA;AXiuCF;;AW9tCA;EACE;IACE,0BAAA;EXiuCF;AACF;AW9tCA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gCAAA;EACA,mBAAA;AXguCF;;AW7tCA;EACE,aAAA;EACA,mBAAA;AXguCF;;AW7tCA;EACE,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cRoMkB;EQnMlB,eAAA;AXguCF;AW9tCE;EACE,cR+LM;AHiiCV;;AW5tCA;EACE,cRwLW;AHuiCb;AW7tCE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,mBR8KS;AHijCb;;AW3tCA;EACE,WAAA;AX8tCF;;AW3tCA;EACE,aAAA;AX8tCF;;AW3tCA;EACE,aAAA;AX8tCF;;AW3tCA;EACE,aAAA;AX8tCF;;AW3tCA;EACE,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,8CAAA;AX8tCF;;AW3tCA;EACE,kBAAA;EACA,gBAAA;EACA,cR+IQ;AH+kCV;;AW3tCA;EACE,aAAA;EACA,gDAAA;EACA,aAAA;AX8tCF;;AW3tCA;EACE,gDAAA;AX8tCF;;AW3tCA;EACE;IACE,gDAAA;EX8tCF;AACF;AW3tCA;EACE,kBAAA;EACA,gBAAA;AX6tCF;;AW1tCA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cRoHkB;AHymCpB;AW3tCE;EACE,cRgHM;AH6mCV;;AWztCA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AX4tCF;;AWztCA;EACE;IACE,0BAAA;EX4tCF;AACF;AWztCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AX2tCF;;AWxtCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cRoFQ;AHuoCV;;AY32CA,0CAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AZ82CF;;AY32CA;EACE;IACE,0BAAA;EZ82CF;AACF;AY32CA,iCAAA;AACA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AZ62CF;;AY12CA;EACE;IACE,gDAAA;EZ62CF;AACF;AY12CA;EACE;IACE,0BAAA;EZ42CF;AACF;AYz2CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cT6LQ;AH8qCV;;AYx2CA;EACE,UAAA;EACA,WAAA;EACA,oBAAA;AZ22CF;;AYx2CA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AZ22CF;;AYx2CA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,cT0KkB;ESzKlB,mBAAA;AZ22CF;AYz2CE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AZ22CJ;;AYv2CA;EACE,gBAAA;EACA,cT6JQ;AH6sCV;;AYv2CA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;AZ02CF;;AYv2CA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBTmJY;ESlJZ,kBAAA;EACA,YAAA;EACA,eAAA;AZ02CF;;AYv2CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,cToIkB;AHsuCpB;;AYv2CA;EACE,gBAAA;EACA,cT8HQ;AH4uCV;;AYv2CA;EACE,uBAAA;EACA,aAAA;AZ02CF;;AYr2CE;EACE,WAAA;AZw2CJ;AYt2CE;EACE,UAAA;AZw2CJ;AYt2CE;EACE,UAAA;AZw2CJ;;Aa/9CA,gDAAA;AACA;EACE,aAAA;EACA,wDAAA;EACA,SAAA;Abk+CF;;Aa/9CA;EACE;IACE,0BAAA;Ebk+CF;AACF;Aa/9CA;EACE,yBAAA;EACA,mBV0NY;EUzNZ,kBAAA;EACA,aAAA;Abi+CF;;Aa99CA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cVyMkB;AHwxCpB;;Aa99CA;EACE,eAAA;EACA,eAAA;EACA,cVmMkB;AH8xCpB;;Aa99CA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;Abi+CF;;Aa99CA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;Abi+CF;;Aa99CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cVwKQ;AHyzCV;;Aa79CA;EACE,eAAA;EACA,gBAAA;Abg+CF;;Aa79CA;EACE,gBAAA;EACA,eAAA;EACA,cV6JkB;EU5JlB,aAAA;EACA,sBAAA;EACA,QAAA;Abg+CF;;Aa59CE;EACE,yBAAA;Ab+9CJ;Aa79CE;EACE,yBAAA;Ab+9CJ;;Aa19CE;EACE,aAAA;Ab69CJ;Aa39CE;EACE,aAAA;Ab69CJ;;Aaz9CA;EACE,eAAA;EACA,aAAA;EACA,gBAAA;Ab49CF;;Ac/jDA,yCAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AdkkDF;;Ac/jDA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cXsNc;AH42ChB;;Ac/jDA;EACE,kBAAA;AdkkDF;;Ac/jDA;;;;;EAAA;AAMA;EACE,wBAAA;EACA,SAAA;AdkkDF;;Ac/jDA;EACE,sBAAA;EACA,SAAA;AdkkDF;;Ac/jDA;EACE,wBAAA;EACA,YAAA;AdkkDF;;Ac/jDA;EACE,sBAAA;EACA,YAAA;AdkkDF;;Ac/jDA;EACE,gBAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,8CAAA;AdkkDF;;Ac/jDA;EACE,gBAAA;EACA,cXqKQ;AH65CV;;Ac/jDA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cX6JQ;AHq6CV;;Ac/jDA;EACE,eAAA;EACA,gBAAA;EACA,cXqJW;AH66Cb;;Ac/jDA;EACE,eAAA;EACA,cXmJkB;AH+6CpB;;Ac/jDA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,cXyIW;EWxIX,gBAAA;AdkkDF;;Ae5pDA,6CAAA;AACA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;Af+pDF;;Ae5pDA;EACE,yBAAA;EACA,mBZ8NY;EY7NZ,kBAAA;EACA,YAAA;Af+pDF;;Ae5pDA;EACE,eAAA;EACA,gBAAA;EACA,cZiNQ;AH88CV;;Ae5pDA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,eAAA;Af+pDF;;Ae5pDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,cZkMkB;AH69CpB;;Ae5pDA;EACE,eAAA;EACA,gBAAA;EACA,cZ2LQ;AHo+CV;;Ae5pDA,oEAAA;AACA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cZoLkB;AH2+CpB;;Ae5pDA,iDAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBZ0KY;EYzKZ,kBAAA;Af+pDF;;Ae5pDA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;Af+pDF;;Ae5pDA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;Af+pDF;;Ae5pDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;Af+pDF;;Ae3pDA;EACG,iCAAA;Af8pDH;;Ae5pDA;EACG,mCAAA;Af+pDH;;Ae5pDA;EACE,wBAAA;Af+pDF;;Ae7pDA;EACE,wBAAA;AfgqDF;;Ae9pDA;EACE,wBAAA;AfiqDF;;Ae9pDA;EACE,YAAA;EACA,oBAAA;AfiqDF;Ae/pDE;EACE,yBAAA;AfiqDJ;Ae9pDE;EACE,yBAAA;AfgqDJ;Ae7pDE;EACE,yBAAA;Af+pDJ;Ae5pDE;EACE,yBAAA;Af8pDJ;;Ae1pDA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;Af6pDF;;AgB/xDA,+CAAA;AACA;EACE,UAAA;EACA,gBAAA;AhBkyDF;AgBhyDE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AhBkyDJ;AgB/xDE;;;EAGE,mBAAA;AhBiyDJ;AgB9xDE;;EAEE,gBAAA;EACA,uBAAA;AhBgyDJ;AgB7xDE;;EAEE,SAAA;EACA,mBAAA;AhB+xDJ;;AgB3xDA;EACE,aAAA;AhB8xDF;;AgB3xDA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;AhB8xDF;;AgB3xDA;EACE,aAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AhB8xDF;;AgBxxDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cboKQ;EanKR,eAAA;AhB2xDF;AgBzxDE;EACE,qBb8JS;AH6nDb;AgBxxDE;EACE,mBAAA;EACA,YAAA;AhB0xDJ;;AgBtxDA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AhByxDF;;AgBtxDA;EACE,yBAAA;AhByxDF;;AgBtxDA;EACE,eAAA;AhByxDF;;AgBtxDA;EACE,gBAAA;EACA,cbuIQ;AHkpDV;;AgBtxDA;EACE,mBAAA;AhByxDF;;AgBtxDA;EACE,qBAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,cbwHQ;EavHR,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AhByxDF;AgBvxDE;EACE,cb8GS;Ea7GT,0BAAA;AhByxDJ;;AgBrxDA;EACE,gBAAA;EACA,cbyGQ;AH+qDV;;AgBrxDA;EACE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;AhBwxDF;;AgBrxDA;EACE,aAAA;AhBwxDF;;AgBrxDA;;;EAGE,SAAA;EACA,gBAAA;EACA,mBAAA;AhBwxDF;;AgBrxDA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AhBwxDF;;AgBrxDA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,cb0EkB;EazElB,kBAAA;AhBwxDF;;AgBrxDA;EACE;IACE,oBAAA;EhBwxDF;AACF;AiB17DA,iCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AjB47DF;;AiBz7DA;EACE,2BAAA;AjB47DF;;AiBz7DA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cdmNkB;AHyuDpB;;AiBz7DA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjB47DF;;AiBz7DA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AjB47DF;;AiBz7DA;EAmBE,+EAAA;AjB06DF;AiB57DE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AjB87DJ;AiB37DE;EACE,SAAA;EACA,aAAA;AjB67DJ;AiB17DE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AjB47DJ;AiBx7DE;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AjB07DJ;;AiBt7DA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;AjBy7DF;;AiBt7DA;EACE,yBAAA;EACA,mBdkKY;EcjKZ,kBAAA;EACA,YAAA;AjBy7DF;;AiBt7DA;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cdqJkB;AHoyDpB;;AiBt7DA;EACE,eAAA;EACA,gBAAA;EACA,cd8IQ;AH2yDV;;AiBt7DA;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AjBy7DF;;AiBt7DA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cd6HQ;AH4zDV;;AiBt7DA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cdmHQ;AHs0DV;AiBv7DE;EACE,cd8GS;AH20Db;;AiBr7DA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AjBw7DF;;AiBr7DA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cd6FQ;Ec5FR,eAAA;AjBw7DF;AiBt7DE;EACE,qBduFS;AHi2Db;;AiBl7DA,eAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AjBq7DF;;AiBl7DA;;EAEE,qBAAA;AjBq7DF;;AiB/6DA;;EAEE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;AjBk7DF;;AiB/6DA;EACE,cAAA;AjBk7DF;;AiB/6DA,cAAA;AACA;EACE,YAAA;EACA,sBAAA;AjBk7DF;;AiB/6DA;;EAEE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;EACA,sBAAA;AjBk7DF;;AiB/6DA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AjBk7DF;;AiB/6DA;EACE,gCAAA;EACA,oCAAA;AjBk7DF;;AiB/6DA;;EAEE,gCAAA;EACA,oCAAA;EACA,yDAAA;AjBk7DF;;AkB3oEA,iEAAA;AACA;EACE,mBAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AlB8oEF;;AkB3oEA;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gFAAA;AlB8oEF;AkB5oEE;EACE,cAAA;AlB8oEJ;;AkB1oEA;EACE,mBAAA;EACA,cAAA;EACA,4CAAA;AlB6oEF;;AkB1oEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AlB6oEF;;AkB1oEA;EACE,YAAA;AlB6oEF;AkB3oEE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlB6oEJ;;AkBzoEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cfiKQ;EehKR,eAAA;EACA,sBAAA;EACA,cAAA;AlB4oEF;AkB1oEE;EACE,qBfyJS;AHm/Db;;AkBvoEA;EACE,2BAAA;AlB0oEF;;AkBtoEE;EACE,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AlByoEJ;;AkBnoEE;EAEE,qBAAA;EACA,mBAAA;AlBqoEJ;AkBloEE;EAEE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AlBmoEJ;AkBjoEI;EACE,mBAAA;AlBmoEN;AkB/nEE;EAEE,mBAAA;EACA,cAAA;EACA,4CAAA;AlBgoEJ;AkB/nEI;EACF,iBAAA;AlBioEF","sourcesContent":["@charset \"UTF-8\";\n.paid-media-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 18px 18px 0;\n}\n\n/*\n * Recharts positions the tooltip under the cursor. Without this the tooltip itself\n * swallows the pointer, so the chart never gets the `mouseleave` that would hide it and\n * the tooltip stays stuck until another click lands elsewhere.\n */\n.paid-media-overview__chart-tooltip-wrapper {\n  pointer-events: none;\n}\n\n/*\n * Visible keyboard focus for every interactive control in the dashboard.\n * Uses :focus-visible so pointer users do not see a ring on click.\n */\n.paid-media-overview button:focus-visible,\n.paid-media-overview a:focus-visible,\n.paid-media-overview input:focus-visible,\n.paid-media-overview select:focus-visible,\n.paid-media-overview [role=tab]:focus-visible {\n  outline: 2px solid #2b74e4;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/**\n * Chart surfaces stay LTR so Recharts' absolute SVG coordinates and `text-anchor` keep working;\n * the mirroring is applied through props instead (see `usePaidMediaChartRtl`). The drawer chart is\n * portalled outside `.paid-media-overview`, so these are keyed on the chart wrappers rather than\n * on an ancestor.\n */\n.paid-media-overview__chart .recharts-surface,\n.paid-media-overview__investment-chart .recharts-surface,\n.paid-media-overview__quadrant-chart .recharts-surface {\n  direction: ltr;\n}\n\n/* ---------- Header ---------- */\n.paid-media-overview__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 16px 20px;\n  padding: 0 0 12px;\n  margin: 0 0 12px;\n  border-bottom: 1px solid #e4e7ec;\n}\n\n.paid-media-overview__header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-start;\n  text-align: start;\n  max-width: 550px;\n}\n\n.paid-media-overview__title {\n  margin: 0;\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #101828;\n}\n\n.paid-media-overview__subtitle {\n  margin: 0;\n  max-width: 760px;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #667085;\n}\n\n.paid-media-overview__header-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  position: relative;\n  margin-inline-start: auto;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n.paid-media-overview__header-row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  width: fit-content;\n}\n\n.paid-media-overview__header-row--bottom {\n  width: fit-content;\n  justify-content: flex-start;\n  gap: 6px;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow: visible;\n}\n\n/* ---------- Segmented control ---------- */\n.paid-media-overview__segmented {\n  display: inline-flex;\n  padding: 2px;\n  border-radius: 8px;\n  background: #edf3fb;\n  gap: 2px;\n  align-self: flex-end;\n  border: 0;\n  margin: 0;\n  min-width: 0;\n}\n\n.paid-media-overview__segmented--sm {\n  font-size: 11px;\n}\n\n.paid-media-overview__segmented--md {\n  font-size: 12px;\n}\n\n.paid-media-overview__segmented-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.paid-media-overview__segmented-btn {\n  border: 0;\n  background: transparent;\n  border-radius: 8px;\n  padding: 14px 14px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.2;\n  letter-spacing: 0.01em;\n  color: #64748b;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.paid-media-overview__segmented-btn:hover {\n  color: #0f172a;\n  background: rgba(255, 255, 255, 0.86);\n}\n\n/* Options the backend cannot serve yet stay visible but non-interactive. */\n.paid-media-overview__segmented-btn:disabled,\n.paid-media-overview__segmented-btn:disabled:hover {\n  color: #94a3b8;\n  background: transparent;\n  cursor: not-allowed;\n}\n\n.paid-media-overview__segmented-btn--active {\n  background: rgb(43, 104, 173);\n  color: #ffffff;\n  box-shadow: none;\n}\n\n.paid-media-overview__segmented-btn--active:hover {\n  background: rgb(43, 104, 173);\n  color: #ffffff;\n  transform: none;\n}\n\n.paid-media-overview__date-range {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 6px 10px;\n  min-height: 36px;\n  font-size: 12px;\n  color: #64748b;\n  width: fit-content;\n  flex-wrap: nowrap;\n}\n.paid-media-overview__date-range input {\n  border: 0;\n  background: transparent;\n  font-size: 12px;\n  width: 96px;\n  outline: none;\n  color: #0f172a;\n  padding: 0;\n}\n\n.paid-media-overview__more-filters {\n  position: relative;\n  overflow: visible;\n}\n\n.paid-media-overview__more-filters-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 8px 14px;\n  min-height: 48px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f172a;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.paid-media-overview__more-filters-trigger:hover {\n  border-color: rgb(43, 104, 173);\n  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.14);\n}\n\n.paid-media-overview__segmented-option {\n  position: relative;\n}\n\n.paid-media-overview__segmented-tooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 30;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n}\n\n.paid-media-overview__segmented-tooltip.is-visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.paid-media-overview__segmented-tooltip--end {\n  left: auto;\n  right: 0;\n  transform: none;\n}\n\n.paid-media-overview__segmented-tooltip-card {\n  min-width: 280px;\n  max-width: min(320px, 100vw - 24px);\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);\n}\n\n.paid-media-overview__segmented-tooltip-title {\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: #0f172a;\n}\n\n.paid-media-overview__segmented-tooltip-description {\n  font-size: 12px;\n  line-height: 1.45;\n  color: #475569;\n  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n.paid-media-overview__more-filters-panel {\n  position: absolute;\n  inset-inline-end: 0;\n  top: calc(100% + 6px);\n  z-index: 20;\n  width: 288px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Arabic: open toward the physical right so the panel stays inside the viewport. */\n[dir=rtl] .paid-media-overview__header .paid-media-overview__segmented-tooltip--end {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .paid-media-overview__header .paid-media-overview__more-filters-panel {\n  inset-inline-end: auto;\n  inset-inline-start: auto;\n  right: auto;\n  left: 0;\n}\n\n/* Safety: the dashboard shell hides horizontal overflow; relax it while the panel is open in Arabic. */\n[dir=rtl] .paid-media-dashboard:has(.paid-media-overview__more-filters--open) {\n  overflow-x: visible;\n}\n\n.paid-media-overview__filter-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n}\n\n.paid-media-overview__filter-label-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n.paid-media-overview__filter-label-row .paid-media-overview__filter-label {\n  margin-bottom: 0;\n}\n\n.paid-media-overview__filter-row--disabled .paid-media-overview__filter-label {\n  color: #94a3b8;\n}\n\n.paid-media-overview__filter-select {\n  width: 100%;\n}\n.paid-media-overview__filter-select .sales-product-analytics-dashboard__select-trigger {\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #ffffff;\n  font-size: 12px;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__filter-select--disabled .sales-product-analytics-dashboard__select-trigger,\n.paid-media-overview__filter-select--disabled .sales-product-analytics-dashboard__select-trigger--disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n  background: #f8fafc;\n  color: #64748b;\n  border-color: #e2e8f0;\n}\n\n.paid-media-overview__filter-select-dropdown {\n  max-height: min(240px, 100vh - 120px);\n  overflow-y: auto;\n  scrollbar-color: #cbd5e1 transparent;\n  scrollbar-width: thin;\n}\n.paid-media-overview__filter-select-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n.paid-media-overview__filter-select-dropdown::-webkit-scrollbar-track {\n  background: transparent;\n}\n.paid-media-overview__filter-select-dropdown::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: #cbd5e1;\n}\n\n/* ---------- Partial-data warnings banner ---------- */\n.paid-media-overview__warnings {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  border: 1px solid rgba(255, 108, 0, 0.4);\n  background: rgba(255, 108, 0, 0.08);\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n\n.paid-media-overview__warnings-icon {\n  display: inline-flex;\n  color: #ff6c00;\n  margin-top: 1px;\n}\n\n.paid-media-overview__warnings-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.paid-media-overview__warnings-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #ff6c00;\n}\n\n.paid-media-overview__warnings-list {\n  margin: 0;\n  padding-inline-start: 16px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #1a1a1a;\n}\n\n/* ---------- KPI grid ---------- */\n.paid-media-overview__kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.paid-media-overview__kpi-card {\n  min-height: 140px;\n}\n\n.paid-media-overview__kpi-card.dashboard-kpi-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);\n  padding: 18px 20px;\n  min-height: 168px;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__title {\n  color: #667085;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__value {\n  color: #101828;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  white-space: normal;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__sublabel,\n.paid-media-overview__kpi-card .dashboard-kpi-card__comparison,\n.paid-media-overview__kpi-card .dashboard-kpi-card__footer,\n.paid-media-overview__kpi-card .dashboard-kpi-card__description {\n  color: #667085;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__change {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: #eef4ff;\n  color: #2563eb;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__title-row {\n  margin-bottom: 20px;\n}\n\n@media (max-width: 1280px) {\n  .paid-media-overview__kpi-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (max-width: 1023px) {\n  .paid-media-overview__header {\n    flex-direction: column;\n    align-items: stretch;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n  }\n  .paid-media-overview__header-actions {\n    margin-inline-start: 0;\n    align-items: flex-end;\n    width: 100%;\n  }\n  .paid-media-overview__header-row {\n    justify-content: flex-end;\n    width: 100%;\n    flex-wrap: wrap;\n  }\n  .paid-media-overview__header-row--bottom {\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n@media (max-width: 639px) {\n  .paid-media-overview__kpi-grid {\n    grid-template-columns: 1fr;\n  }\n  .paid-media-overview__header {\n    gap: 6px;\n    padding: 0 0 2px;\n  }\n  .paid-media-overview__header-copy {\n    gap: 2px;\n  }\n  .paid-media-overview__title {\n    font-size: 24px;\n  }\n  .paid-media-overview__subtitle {\n    font-size: 13px;\n  }\n  .paid-media-overview__header-actions {\n    width: 100%;\n    align-items: flex-end;\n    gap: 6px;\n    margin-inline-start: 0;\n  }\n  .paid-media-overview__header-row:not(.paid-media-overview__header-row--bottom) {\n    width: 100%;\n    max-width: 100%;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: flex-end;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  .paid-media-overview__header-row:not(.paid-media-overview__header-row--bottom)::-webkit-scrollbar {\n    display: none;\n  }\n  .paid-media-overview__header-row--bottom {\n    flex-direction: row;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n  }\n  .paid-media-overview__segmented,\n  .paid-media-overview__date-range,\n  .paid-media-overview__more-filters-trigger {\n    width: auto;\n    max-width: none;\n    justify-content: flex-end;\n    flex-shrink: 0;\n  }\n  .paid-media-overview__segmented {\n    display: inline-flex;\n    min-width: fit-content;\n  }\n  .paid-media-overview__segmented-btn {\n    padding: 7px 10px;\n    font-size: 11px;\n  }\n  .paid-media-overview__date-range {\n    flex-wrap: nowrap;\n    padding: 6px 8px;\n  }\n  .paid-media-overview__date-range input {\n    width: 84px;\n    min-width: 0;\n  }\n  .paid-media-overview__more-filters-trigger {\n    padding: 7px 10px;\n  }\n}\n/* ---------- Shared panel bits ---------- */\n.paid-media-overview__panel-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px 12px;\n  margin-bottom: 12px;\n  /* Lets the title column wrap instead of being squeezed by the legend. */\n}\n.paid-media-overview__panel-header h3 {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n.paid-media-overview__panel-header > div {\n  min-width: 0;\n}\n\n/* The overview spaces its rows with grid `gap`, so the shared panel's own bottom\n * margin has to go — otherwise two panels in the same row end at different\n * heights (the margin is subtracted from the stretched item). */\n.paid-media-overview__trend-grid > .paid-media-panel,\n.paid-media-overview__two-col-grid > .paid-media-panel,\n.paid-media-overview__comparison-grid > .paid-media-panel,\n.paid-media-overview__insight-stack > .paid-media-panel {\n  margin-bottom: 0;\n}\n\n.paid-media-overview__panel-subtitle {\n  margin: 2px 0 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.paid-media-overview__panel-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.paid-media-overview__panel-header-note {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n  white-space: nowrap;\n}\n\n/* Four platform averages sit two per line so they cannot squeeze the title. */\n.paid-media-overview__legend-inline {\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  justify-content: end;\n  gap: 2px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 767px) {\n  .paid-media-overview__legend-inline {\n    justify-content: start;\n  }\n}\n.paid-media-overview__chart-legend-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin: 8px 0 12px;\n  padding: 0;\n  background: transparent;\n  border: 0;\n}\n\n.paid-media-overview__chart-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border-radius: 0;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #475569;\n  background: transparent;\n}\n\n.paid-media-overview__chart-legend-item--purple {\n  color: #8d4fd3;\n}\n\n.paid-media-overview__chart-legend-item--green {\n  color: #5abf8b;\n}\n\n.paid-media-overview__chart-legend-item--mint {\n  color: #94d0b5;\n}\n\n.paid-media-overview__chart-legend-item--meta {\n  color: #2b74e4;\n}\n\n.paid-media-overview__chart-legend-item--google {\n  color: #f6c15f;\n}\n\n.paid-media-overview__chart-legend-item--meta-revenue {\n  color: #5d97ee;\n}\n\n.paid-media-overview__chart-legend-item--google-revenue {\n  color: #f0a84a;\n}\n\n.paid-media-overview__chart-legend-swatch {\n  width: 20px;\n  height: 14px;\n  border-radius: 0;\n  flex-shrink: 0;\n}\n\n.paid-media-overview__chart-legend-swatch--purple {\n  background: #8d4fd3;\n}\n\n.paid-media-overview__chart-legend-swatch--green {\n  background: #5abf8b;\n}\n\n.paid-media-overview__chart-legend-swatch--mint {\n  background: #94d0b5;\n}\n\n.paid-media-overview__chart-legend-swatch--meta {\n  background: #2b74e4;\n}\n\n.paid-media-overview__chart-legend-swatch--google {\n  background: #f6c15f;\n}\n\n.paid-media-overview__chart-legend-swatch--meta-revenue {\n  background: #5d97ee;\n}\n\n.paid-media-overview__chart-legend-swatch--google-revenue {\n  background: #f0a84a;\n}\n\n.paid-media-overview__callout {\n  margin-top: 12px;\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #6b7280;\n}\n.paid-media-overview__callout strong {\n  color: #1a1a1a;\n}\n\n.paid-media-overview__callout--success {\n  border-color: #c9e5cf;\n  background: #f0f8f2;\n  color: #1a1a1a;\n}\n.paid-media-overview__callout--success strong {\n  color: #28a745;\n}\n\n.paid-media-overview__text-success {\n  color: #28a745;\n}\n\n.paid-media-overview__text-danger {\n  color: #e53935;\n}\n\n.paid-media-overview__text-warning {\n  color: #ff6c00;\n}\n\n/* Shown in place of a chart when the series has no rows. */\n.paid-media-overview__chart-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 160px;\n  padding: 16px;\n  border: 1px dashed #e5e7eb;\n  border-radius: 8px;\n  background: #f8fafc;\n  font-size: 13px;\n  color: #6b7280;\n  text-align: center;\n}\n\n/* ---------- Comparison cards ---------- */\n.paid-media-overview__comparison-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n/* The two insight cards carry little content, so they keep their natural height\n * and sit centred in the column: the leftover height is split evenly above and\n * below the pair instead of leaving a gap between them. */\n.paid-media-overview__insight-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n  height: 100%;\n}\n\n.paid-media-overview__insight-stack .paid-media-overview__insight-card {\n  flex: 1 1 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n@media (max-width: 1279px) {\n  .paid-media-overview__comparison-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 639px) {\n  .paid-media-overview__comparison-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.paid-media-overview__platform-card,\n.paid-media-overview__insight-card {\n  padding: 16px;\n}\n\n.paid-media-overview__platform-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.paid-media-overview__platform-card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n.paid-media-overview__platform-card-title span:last-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.paid-media-overview__platform-card-icon {\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  color: #ffffff;\n}\n\n.paid-media-overview__platform-card-tag {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n}\n\n.paid-media-overview__platform-card-metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 12px;\n  font-size: 12px;\n}\n\n.paid-media-overview__metric-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n}\n\n.paid-media-overview__metric-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__platform-card-shares {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.paid-media-overview__insight-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.paid-media-overview__insight-card-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n}\n\n.paid-media-overview__insight-card-icon {\n  color: #9ca3af;\n}\n\n.paid-media-overview__insight-card-value {\n  margin-top: 8px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__insight-card-copy {\n  margin: 8px 0 0;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #6b7280;\n}\n.paid-media-overview__insight-card-copy strong {\n  color: #1a1a1a;\n}\n\n.paid-media-overview__insight-card-callout {\n  margin-top: 12px;\n  border-radius: 6px;\n  padding: 6px 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.paid-media-overview__insight-card-callout--positive {\n  border: 1px solid #c9e5cf;\n  background: #f0f8f2;\n  color: #28a745;\n}\n\n.paid-media-overview__insight-card-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 12px;\n  margin-top: 12px;\n  font-size: 11px;\n  color: #6b7280;\n}\n.paid-media-overview__insight-card-legend strong {\n  color: #1a1a1a;\n}\n\n/* ---------- Platform palette ----------\n * Slugs match `OverviewPlatformDescriptor.slug`; the fill colours match the\n * chart series colours in the same registry.\n */\n/* Darkened for text and small dots, where the chart fill is too light to read. */\n.paid-media-overview__share-bar-fill--meta-ads {\n  background-color: #2b74e4;\n}\n\n.paid-media-overview__platform-dot-swatch--meta {\n  background-color: #2b74e4;\n}\n\n.paid-media-overview__drawer-platform-tag--meta {\n  background-color: #2b74e4;\n}\n\n.paid-media-overview__funnel[data-platform=meta] .paid-media-overview__funnel-dot,\n.paid-media-overview__funnel[data-platform=meta] .paid-media-overview__funnel-bar {\n  background-color: #2b74e4;\n}\n\n.paid-media-overview__share-bar-fill--google-ads {\n  background-color: #f6c15f;\n}\n\n.paid-media-overview__platform-dot-swatch--google {\n  background-color: #f6c15f;\n}\n\n.paid-media-overview__drawer-platform-tag--google {\n  background-color: #f6c15f;\n}\n\n.paid-media-overview__funnel[data-platform=google] .paid-media-overview__funnel-dot,\n.paid-media-overview__funnel[data-platform=google] .paid-media-overview__funnel-bar {\n  background-color: #f6c15f;\n}\n\n.paid-media-overview__share-bar-fill--tiktok-ads {\n  background-color: #ff3b5c;\n}\n\n.paid-media-overview__platform-dot-swatch--tiktok {\n  background-color: #ff3b5c;\n}\n\n.paid-media-overview__drawer-platform-tag--tiktok {\n  background-color: #ff3b5c;\n}\n\n.paid-media-overview__funnel[data-platform=tiktok] .paid-media-overview__funnel-dot,\n.paid-media-overview__funnel[data-platform=tiktok] .paid-media-overview__funnel-bar {\n  background-color: #ff3b5c;\n}\n\n.paid-media-overview__share-bar-fill--snapchat-ads {\n  background-color: #0ea5a4;\n}\n\n.paid-media-overview__platform-dot-swatch--snapchat {\n  background-color: #0ea5a4;\n}\n\n.paid-media-overview__drawer-platform-tag--snapchat {\n  background-color: #0ea5a4;\n}\n\n.paid-media-overview__funnel[data-platform=snapchat] .paid-media-overview__funnel-dot,\n.paid-media-overview__funnel[data-platform=snapchat] .paid-media-overview__funnel-bar {\n  background-color: #0ea5a4;\n}\n\n.paid-media-overview__index-row-dot--meta {\n  background-color: #2b74e4;\n}\n\n.paid-media-overview__legend-inline-item--meta {\n  color: #2b74e4;\n}\n\n.paid-media-overview__chart-tooltip-heading--meta {\n  color: #2b74e4;\n}\n\n.paid-media-overview__index-row-dot--google {\n  background-color: #c18a2f;\n}\n\n.paid-media-overview__legend-inline-item--google {\n  color: #c18a2f;\n}\n\n.paid-media-overview__chart-tooltip-heading--google {\n  color: #c18a2f;\n}\n\n.paid-media-overview__index-row-dot--tiktok {\n  background-color: #e11d48;\n}\n\n.paid-media-overview__legend-inline-item--tiktok {\n  color: #e11d48;\n}\n\n.paid-media-overview__chart-tooltip-heading--tiktok {\n  color: #e11d48;\n}\n\n.paid-media-overview__index-row-dot--snapchat {\n  background-color: #0f766e;\n}\n\n.paid-media-overview__legend-inline-item--snapchat {\n  color: #0f766e;\n}\n\n.paid-media-overview__chart-tooltip-heading--snapchat {\n  color: #0f766e;\n}\n\n/* Card badges keep each network's own brand colour. */\n.paid-media-overview__platform-card-icon--meta {\n  background-color: #2b74e4;\n}\n.paid-media-overview__platform-card-icon--google {\n  background-color: #f6c15f;\n}\n.paid-media-overview__platform-card-icon--tiktok {\n  background-color: #010101;\n}\n.paid-media-overview__platform-card-icon--snapchat {\n  background-color: #fffc00;\n  color: #111827;\n}\n\n.paid-media-overview__platform-dot-swatch--unknown,\n.paid-media-overview__drawer-platform-tag--unknown {\n  background-color: #9ca3af;\n}\n\n/* ---------- Share bar ---------- */\n.paid-media-overview__share-bar-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  font-size: 12px;\n}\n\n.paid-media-overview__share-bar-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #6b7280;\n}\n\n.paid-media-overview__share-bar-value {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__share-bar-track {\n  height: 8px;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #e5e7eb;\n}\n\n.paid-media-overview__share-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  /* Live percentage supplied by OverviewShareBar; 0% until it is set. */\n  width: var(--paid-media-share-bar-value, 0%);\n}\n\n/* ---------- Status badge / platform dot ---------- */\n.paid-media-overview__status-badge {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 6px;\n  border: 1px solid;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.paid-media-overview__status-badge .definition-tooltip {\n  position: absolute;\n  inset: 0;\n  display: block;\n}\n\n.paid-media-overview__status-badge .definition-tooltip__trigger {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  min-height: 0;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  opacity: 0;\n  cursor: help;\n}\n\n.paid-media-overview__platform-dot {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.paid-media-overview__platform-dot-swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n}\n\n/*\n * Status badge palette. Modifier slugs are produced by `overviewStatusModifier`,\n * so the badge component ships class names only and carries no inline styles.\n */\n.paid-media-overview__status-badge--scale-winner {\n  color: #28a745;\n  border-color: #28a745;\n  background-color: rgba(40, 167, 69, 0.07);\n}\n\n.paid-media-overview__status-badge--efficiency-winner {\n  color: #2b74e4;\n  border-color: #2b74e4;\n  background-color: rgba(43, 116, 228, 0.07);\n}\n\n.paid-media-overview__status-badge--growth-opportunity {\n  color: #8d4fd3;\n  border-color: #8d4fd3;\n  background-color: rgba(141, 79, 211, 0.07);\n}\n\n.paid-media-overview__status-badge--stable {\n  color: #6b7280;\n  border-color: #6b7280;\n  background-color: rgba(107, 114, 128, 0.07);\n}\n\n.paid-media-overview__status-badge--high-spend-low-return {\n  color: #e53935;\n  border-color: #e53935;\n  background-color: rgba(229, 57, 53, 0.07);\n}\n\n.paid-media-overview__status-badge--needs-review {\n  color: #ff6c00;\n  border-color: #ff6c00;\n  background-color: rgba(255, 108, 0, 0.07);\n}\n\n.paid-media-overview__status-badge--low-priority {\n  color: #6b7280;\n  border-color: #6b7280;\n  background-color: rgba(107, 114, 128, 0.07);\n}\n\n.paid-media-overview__status-badge--unknown {\n  color: #6b7280;\n  border-color: #6b7280;\n  background-color: rgba(107, 114, 128, 0.07);\n}\n\n/* ---------- Trend + contribution row ---------- */\n.paid-media-overview__trend-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 7fr) minmax(280px, 3fr);\n  gap: 12px;\n}\n\n@media (max-width: 1279px) {\n  .paid-media-overview__trend-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.paid-media-overview__trend-metric-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 12px;\n}\n\n.paid-media-overview__trend-metric-tab {\n  display: flex;\n  align-items: center;\n}\n\n.paid-media-overview__trend-metric-btn {\n  position: relative;\n  border: 0;\n  background: transparent;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n}\n.paid-media-overview__trend-metric-btn:hover {\n  color: #1a1a1a;\n}\n\n.paid-media-overview__trend-metric-btn--active {\n  color: #2b74e4;\n}\n.paid-media-overview__trend-metric-btn--active::after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  right: 4px;\n  bottom: -1px;\n  height: 2px;\n  border-radius: 2px 2px 0 0;\n  background: #2b74e4;\n}\n\n.paid-media-overview__chart {\n  width: 100%;\n}\n\n.paid-media-overview__chart--trend {\n  height: 320px;\n}\n\n.paid-media-overview__chart--md {\n  height: 280px;\n}\n\n.paid-media-overview__chart--sm {\n  height: 260px;\n}\n\n.paid-media-overview__chart-tooltip {\n  border: 1px solid #e5e7eb;\n  border-inline-start: 4px solid #2b74e4;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 10px 14px 10px 12px;\n  font-size: 11px;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);\n}\n\n.paid-media-overview__chart-tooltip-title {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__chart-tooltip-columns {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 4px 16px;\n}\n\n.paid-media-overview__chart-tooltip-columns--quad {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__chart-tooltip-columns--quad {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n.paid-media-overview__chart-tooltip-heading {\n  margin-bottom: 2px;\n  font-weight: 600;\n}\n\n.paid-media-overview__chart-tooltip-footer {\n  margin-top: 8px;\n  padding-top: 6px;\n  border-top: 1px solid #e5e7eb;\n  color: #6b7280;\n}\n.paid-media-overview__chart-tooltip-footer strong {\n  color: #1a1a1a;\n}\n\n.paid-media-overview__contribution-rows {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px 24px;\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__contribution-rows {\n    grid-template-columns: 1fr;\n  }\n}\n.paid-media-overview__contribution-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.paid-media-overview__contribution-row-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n/* ---------- Two-column rows ---------- */\n.paid-media-overview__two-col-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__two-col-grid {\n    grid-template-columns: 1fr;\n  }\n}\n/* ---------- Funnel ---------- */\n.paid-media-overview__funnel-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px 24px;\n}\n\n@media (max-width: 1279px) {\n  .paid-media-overview__funnel-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 639px) {\n  .paid-media-overview__funnel-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.paid-media-overview__funnel-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__funnel-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n}\n\n.paid-media-overview__funnel-stages {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.paid-media-overview__funnel-stage-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11px;\n  color: #6b7280;\n  padding-bottom: 5px;\n}\n.paid-media-overview__funnel-stage-row span:first-child {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.paid-media-overview__funnel-stage-value {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__funnel-bar {\n  height: 24px;\n  border-radius: 6px;\n  opacity: 0.85;\n}\n\n.paid-media-overview__funnel-footer {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 12px;\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  border-radius: 6px;\n  padding: 8px;\n  font-size: 11px;\n}\n\n.paid-media-overview__funnel-footer-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  text-transform: uppercase;\n  color: #6b7280;\n}\n\n.paid-media-overview__funnel-footer-value {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__funnel-bar-progress-bar-center {\n  justify-content: center;\n  display: flex;\n}\n\n.paid-media-overview__funnel-bar[data-width=full] {\n  width: 100%;\n}\n.paid-media-overview__funnel-bar[data-width=mid] {\n  width: 68%;\n}\n.paid-media-overview__funnel-bar[data-width=low] {\n  width: 32%;\n}\n\n/* ---------- Investment efficiency ---------- */\n.paid-media-overview__investment-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__investment-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.paid-media-overview__index-panel {\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.paid-media-overview__index-panel-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n}\n\n.paid-media-overview__index-panel-subtitle {\n  margin-top: 4px;\n  font-size: 10px;\n  color: #6b7280;\n}\n\n.paid-media-overview__index-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.paid-media-overview__index-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 6px 8px;\n}\n\n.paid-media-overview__index-row-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__index-row-value {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.paid-media-overview__index-panel-footnote {\n  margin-top: 12px;\n  font-size: 11px;\n  color: #6b7280;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.paid-media-overview__index-row-dot--meta {\n  background-color: #2b74e4;\n}\n.paid-media-overview__index-row-dot--google {\n  background-color: #c18a2f;\n}\n\n.paid-media-overview__share-bar--spend path {\n  fill: #2b74e4;\n}\n.paid-media-overview__share-bar--revenue path {\n  fill: #8d4fd3;\n}\n\n.paid-media-overview__share-bar-label {\n  font-size: 11px;\n  fill: #1a1a1a;\n  font-weight: 600;\n}\n\n/* ---------- Quadrant chart ---------- */\n.paid-media-overview__quadrant-chart {\n  position: relative;\n  height: 360px;\n  width: 100%;\n}\n\n.paid-media-overview__quadrant-labels {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #9ca3af;\n}\n\n.paid-media-overview__quadrant-label {\n  position: absolute;\n}\n\n/*\n * The `tl`/`tr`/`bl`/`br` modifiers name the quadrant in reading order, not in physical sides:\n * the scatter's spend axis counts from the inline start, so in Arabic it counts from the right and\n * these labels have to follow it. Insets are logical for that reason — the wider start inset also\n * clears the value axis, which moves to the right edge with the axis (see `usePaidMediaChartRtl`).\n */\n.paid-media-overview__quadrant-label--tl {\n  inset-inline-start: 56px;\n  top: -8px;\n}\n\n.paid-media-overview__quadrant-label--tr {\n  inset-inline-end: 16px;\n  top: -8px;\n}\n\n.paid-media-overview__quadrant-label--bl {\n  inset-inline-start: 56px;\n  bottom: 18px;\n}\n\n.paid-media-overview__quadrant-label--br {\n  inset-inline-end: 16px;\n  bottom: 18px;\n}\n\n.paid-media-overview__quadrant-tooltip {\n  max-width: 260px;\n  border: 1px solid #e5e7eb;\n  border-inline-start: 4px solid #2b74e4;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 10px 14px 10px 12px;\n  font-size: 11px;\n  line-height: 1.6;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);\n}\n\n.paid-media-overview__quadrant-tooltip-title {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__quadrant-tooltip-body {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__quadrant-tooltip-classification {\n  margin-top: 6px;\n  font-weight: 600;\n  color: #2b74e4;\n}\n\n.paid-media-overview__quadrant-tooltip-reason {\n  margin-top: 4px;\n  color: #6b7280;\n}\n\n.paid-media-overview__quadrant-tooltip-hint {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid #e5e7eb;\n  color: #2b74e4;\n  font-weight: 500;\n}\n\n/* ---------- Revenue validation ---------- */\n.paid-media-overview__variance-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.paid-media-overview__variance-box {\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.paid-media-overview__variance-box-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__variance-box-metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.paid-media-overview__variance-box-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  text-transform: uppercase;\n  color: #6b7280;\n}\n\n.paid-media-overview__variance-box-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n/* Shown in place of the store columns when no store is connected. */\n.paid-media-overview__confidence-footnote {\n  margin-top: 16px;\n  font-size: 11px;\n  line-height: 1.6;\n  color: #6b7280;\n}\n\n/* ---------- Attribution confidence ---------- */\n.paid-media-overview__confidence-score {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 20px 16px;\n  margin-bottom: 20px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #f8fafc;\n  text-align: center;\n}\n\n.paid-media-overview__confidence-score-value {\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #16a34a;\n}\n\n.paid-media-overview__confidence-score-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #16a34a;\n}\n\n.paid-media-overview__confidence-components {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.paid-media-overview-platform-and-store {\n  margin: 5px 10px 5px 0 !important;\n}\n\n.paid-media-daily-spend-revenue-trend {\n  margin: 5px 10px 5px -10 !important;\n}\n\n.platform-reported-bar {\n  fill: #8d4fd3 !important;\n}\n\n.store-gross-bar {\n  fill: #5abf8b !important;\n}\n\n.store-net-bar {\n  fill: #94d0b5 !important;\n}\n\n.paid-media-overview__share-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n}\n.paid-media-overview__share-bar-fill--confidence-green {\n  background-color: #5abf8b;\n}\n.paid-media-overview__share-bar-fill--confidence-blue {\n  background-color: #2b74e4;\n}\n.paid-media-overview__share-bar-fill--confidence-purple {\n  background-color: #8d4fd3;\n}\n.paid-media-overview__share-bar-fill--confidence-orange {\n  background-color: #f6c15f;\n}\n\n.benchmark-reference-label {\n  fill: #8d4fd3;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* ---------- Campaign leaderboard ---------- */\n.paid-media-overview__leaderboard {\n  padding: 0;\n  overflow: hidden;\n}\n.paid-media-overview__leaderboard table {\n  width: max-content;\n  min-width: 100%;\n  table-layout: auto;\n}\n.paid-media-overview__leaderboard table,\n.paid-media-overview__leaderboard th,\n.paid-media-overview__leaderboard td {\n  white-space: nowrap;\n}\n.paid-media-overview__leaderboard th,\n.paid-media-overview__leaderboard td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.paid-media-overview__leaderboard th:last-child,\n.paid-media-overview__leaderboard td:last-child {\n  width: 1%;\n  white-space: nowrap;\n}\n\n.paid-media-overview__leaderboard-header {\n  padding: 16px;\n}\n\n.paid-media-overview__leaderboard-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: end;\n  gap: 12px;\n}\n\n.paid-media-overview__leaderboard-platform-tabs {\n  display: flex;\n  gap: 2px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.paid-media-overview__export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n  cursor: pointer;\n}\n.paid-media-overview__export-btn:hover:not(:disabled) {\n  border-color: #2b74e4;\n}\n.paid-media-overview__export-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.paid-media-overview__leaderboard-th {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.paid-media-overview__leaderboard-th--right {\n  justify-content: flex-end;\n}\n\n.paid-media-overview__leaderboard-cell--right {\n  text-align: end;\n}\n\n.paid-media-overview__leaderboard-cell--strong {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__leaderboard-cell--status {\n  white-space: nowrap;\n}\n\n.paid-media-overview__leaderboard-row-link {\n  display: inline-block;\n  max-width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font: inherit;\n  font-weight: 600;\n  color: #1a1a1a;\n  cursor: pointer;\n  text-align: start;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.paid-media-overview__leaderboard-row-link:hover {\n  color: #2b74e4;\n  text-decoration: underline;\n}\n\n.paid-media-overview__cell-strong {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__popover {\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__popover::-webkit-scrollbar {\n  display: none;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__text,\n.paid-media-overview__leaderboard .definition-tooltip__formula,\n.paid-media-overview__leaderboard .definition-tooltip__note {\n  margin: 0;\n  line-height: 1.5;\n  white-space: normal;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__formula-box {\n  margin-top: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n}\n\n.paid-media-overview__leaderboard-empty {\n  margin: 0;\n  padding: 32px 16px;\n  font-size: 13px;\n  color: #6b7280;\n  text-align: center;\n}\n\n@media (min-width: 965px) and (max-width: 1333px) {\n  .paid-media-overview__leaderboard-filters {\n    justify-content: end;\n  }\n}\n/* ---------- Drawer ---------- */\n.paid-media-overview__drawer-title {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ant-drawer-right .ant-drawer-header .ant-drawer-header-title {\n  flex-direction: row-reverse;\n}\n\n.paid-media-overview__drawer-subtitle {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #6b7280;\n}\n\n.paid-media-overview__drawer-platform-tag {\n  border-radius: 6px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.paid-media-overview__drawer-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.paid-media-overview__campaign-drawer {\n  /* Chart no longer has a fixed height: it fills the card and never pushes it. */\n}\n.paid-media-overview__campaign-drawer .ant-drawer-body {\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n}\n.paid-media-overview__campaign-drawer .paid-media-overview__drawer-body {\n  flex: 1;\n  min-height: 0;\n}\n.paid-media-overview__campaign-drawer .paid-media-overview__drawer-chart-card {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n.paid-media-overview__campaign-drawer .paid-media-overview__chart--sm {\n  flex: 1;\n  height: auto;\n  min-height: 180px;\n  min-width: 0;\n}\n\n.paid-media-overview__drawer-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.paid-media-overview__mini-kpi {\n  border: 1px solid #e5e7eb;\n  background: #f8fafc;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.paid-media-overview__mini-kpi-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b7280;\n}\n\n.paid-media-overview__mini-kpi-value {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__drawer-chart-card {\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.paid-media-overview__drawer-chart-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.paid-media-overview__drawer-insight {\n  border: 1px solid #bfd4f2;\n  background: #eaf2fd;\n  border-radius: 6px;\n  padding: 12px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #1a1a1a;\n}\n.paid-media-overview__drawer-insight strong {\n  color: #2b74e4;\n}\n\n.paid-media-overview__drawer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  padding-top: 8px;\n}\n\n.paid-media-overview__drawer-close {\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n  cursor: pointer;\n}\n.paid-media-overview__drawer-close:hover {\n  border-color: #2b74e4;\n}\n\n/* Search box */\n.paid-media-overview__leaderboard-search {\n  height: 48px;\n  min-width: 220px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 14px;\n  background: #ffffff;\n  border: 1px solid #e2e2e6;\n  border-radius: 10px;\n  box-sizing: border-box;\n}\n\n.paid-media-overview__leaderboard-search:hover,\n.paid-media-overview__leaderboard-search:focus-within {\n  border-color: #2b74e4;\n}\n\n.paid-media-overview__leaderboard-search .paid-media-overview__leaderboard-search-input,\n.paid-media-overview__leaderboard-search input {\n  border: none;\n  border-radius: 0;\n  outline: none;\n  padding: 0;\n  font-size: 14px;\n  color: #1a1a1a;\n  background: transparent;\n  width: 100%;\n}\n\n.paid-media-overview__leaderboard-search input::placeholder {\n  color: #9a9a9f;\n}\n\n/* Dropdowns */\n.paid-media-overview__leaderboard-filter-dropdown {\n  height: 48px;\n  box-sizing: border-box;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown .ant-select-selector,\n.paid-media-overview__leaderboard-filter-dropdown.ant-select .ant-select-selector {\n  height: 38px !important;\n  border-radius: 10px !important;\n  padding: 0 14px !important;\n  display: flex;\n  align-items: center;\n  background-color: #ffffff !important;\n  border: 1px solid #e2e2e6 !important;\n  box-sizing: border-box;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown .ant-select-selection-item {\n  font-size: 14px;\n  line-height: 36px;\n  color: #2b74e4;\n  font-weight: 500;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown:hover .ant-select-selector {\n  border-color: #2b74e4 !important;\n  background-color: #ffffff !important;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown.ant-select-focused .ant-select-selector,\n.paid-media-overview__leaderboard-filter-dropdown.ant-select-open .ant-select-selector {\n  border-color: #2b74e4 !important;\n  background-color: #ffffff !important;\n  box-shadow: 0 0 0 2px rgba(43, 116, 228, 0.12) !important;\n}\n\n/* ---------- Level tabs (Campaigns / Ad sets / Ads) ---------- */\n.paid-media-overview__level-tabs {\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  background: #eef1f6;\n  border-radius: 12px;\n  padding: 6px;\n  margin-bottom: 12px;\n}\n\n.paid-media-overview__level-tab {\n  border: 0;\n  background: transparent;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n}\n.paid-media-overview__level-tab:hover {\n  color: #1a1a2e;\n}\n\n.paid-media-overview__level-tab--active {\n  background: #ffffff;\n  color: #1a1a2e;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.paid-media-overview__leaderboard-toprow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.paid-media-overview__panel-header-titles {\n  min-width: 0;\n}\n.paid-media-overview__panel-header-titles h3 {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #101828;\n}\n\n.paid-media-overview__export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 48px;\n  border: 1px solid #e5e7eb;\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 0 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a1a1a;\n  cursor: pointer;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n.paid-media-overview__export-btn:hover {\n  border-color: #2b74e4;\n}\n\n.campaign-leaderboard-article {\n  padding: 0px 0px !important;\n}\n\n.paid-media-overview__leaderboard-table-wrap .dashboard-data-table-card {\n  border: 0;\n  border-top: 1px solid #e5e5e5;\n  border-radius: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.paid-media-overview__granularity-segmented .paid-media-overview__segmented {\n  border-color: #d0d5dd;\n  background: #eef1f6;\n}\n.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn {\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  min-width: 48px;\n  height: 28px;\n  padding: 0 12px;\n  cursor: pointer;\n}\n.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn:hover {\n  background: #eef1f6;\n}\n.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn--active {\n  background: #ffffff;\n  color: #000000;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n.paid-media-overview__granularity-segmented .paid-media-overview__segmented-btn--active:hover {\n  background: white;\n}",".paid-media-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 18px 18px 0;\n}\n\n/*\n * Recharts positions the tooltip under the cursor. Without this the tooltip itself\n * swallows the pointer, so the chart never gets the `mouseleave` that would hide it and\n * the tooltip stays stuck until another click lands elsewhere.\n */\n.paid-media-overview__chart-tooltip-wrapper {\n  pointer-events: none;\n}\n\n/*\n * Visible keyboard focus for every interactive control in the dashboard.\n * Uses :focus-visible so pointer users do not see a ring on click.\n */\n.paid-media-overview {\n  button:focus-visible,\n  a:focus-visible,\n  input:focus-visible,\n  select:focus-visible,\n  [role=\"tab\"]:focus-visible {\n    outline: 2px solid $dt-primary;\n    outline-offset: 2px;\n    border-radius: 4px;\n  }\n}\n\n/**\n * Chart surfaces stay LTR so Recharts' absolute SVG coordinates and `text-anchor` keep working;\n * the mirroring is applied through props instead (see `usePaidMediaChartRtl`). The drawer chart is\n * portalled outside `.paid-media-overview`, so these are keyed on the chart wrappers rather than\n * on an ancestor.\n */\n.paid-media-overview__chart,\n.paid-media-overview__investment-chart,\n.paid-media-overview__quadrant-chart {\n  .recharts-surface {\n    direction: ltr;\n  }\n}\n","/* ---------- Header ---------- */\n.paid-media-overview__header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 16px 20px;\n  padding: 0 0 12px;\n  margin: 0 0 12px;\n  border-bottom: 1px solid #e4e7ec;\n}\n\n.paid-media-overview__header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  //min-width: 0;\n  align-items: flex-start;\n  text-align: start;\n  max-width: 550px;\n}\n\n.paid-media-overview__title {\n  margin: 0;\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #101828;\n}\n\n.paid-media-overview__subtitle {\n  margin: 0;\n  max-width: 760px;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #667085;\n}\n\n.paid-media-overview__header-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  position: relative;\n  margin-inline-start: auto;\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n.paid-media-overview__header-row {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  width: fit-content;\n}\n\n.paid-media-overview__header-row--bottom {\n  width: fit-content;\n  justify-content: flex-start;\n  gap: 6px;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow: visible;\n}\n\n/* ---------- Segmented control ---------- */\n.paid-media-overview__segmented {\n  display: inline-flex;\n    padding: 2px;\n    border-radius: 8px;\n    background: #edf3fb;\n    gap: 2px;\n    align-self: flex-end;\n    border: 0;\n    margin: 0;\n    min-width: 0;\n}\n\n.paid-media-overview__segmented--sm {\n  font-size: 11px;\n}\n\n.paid-media-overview__segmented--md {\n  font-size: 12px;\n}\n\n.paid-media-overview__segmented-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.paid-media-overview__segmented-btn {\n  border: 0;\n  background: transparent;\n  border-radius: 8px;\n  padding: 14px 14px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.2;\n  letter-spacing: 0.01em;\n  color: #64748b;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.paid-media-overview__segmented-btn:hover {\n  color: #0f172a;\n  background: rgba(255, 255, 255, 0.86);\n}\n\n/* Options the backend cannot serve yet stay visible but non-interactive. */\n.paid-media-overview__segmented-btn:disabled,\n.paid-media-overview__segmented-btn:disabled:hover {\n  color: #94a3b8;\n  background: transparent;\n  cursor: not-allowed;\n}\n\n.paid-media-overview__segmented-btn--active {\n  background: $paid-media-accent;\n  color: #ffffff;\n  box-shadow: none;\n}\n\n.paid-media-overview__segmented-btn--active:hover {\n  background: $paid-media-accent;\n  color: #ffffff;\n  transform: none;\n}\n\n.paid-media-overview__date-range {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 6px 10px;\n  min-height: 36px;\n  font-size: 12px;\n  color: #64748b;\n  width: fit-content;\n  flex-wrap: nowrap;\n\n  input {\n    border: 0;\n    background: transparent;\n    font-size: 12px;\n    width: 96px;\n    outline: none;\n    color: #0f172a;\n    padding: 0;\n  }\n}\n\n.paid-media-overview__more-filters {\n  position: relative;\n  overflow: visible;\n}\n\n.paid-media-overview__more-filters-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 8px 14px;\n  min-height: 48px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f172a;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover {\n    border-color: $paid-media-accent;\n    box-shadow: 0 1px 3px rgba(37, 99, 235, 0.14);\n  }\n}\n\n.paid-media-overview__segmented-option {\n  position: relative;\n}\n\n.paid-media-overview__segmented-tooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 30;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.2s ease, visibility 0.2s ease;\n}\n\n.paid-media-overview__segmented-tooltip.is-visible {\n  opacity: 1;\n  visibility: visible;\n}\n\n.paid-media-overview__segmented-tooltip--end {\n  left: auto;\n  right: 0;\n  transform: none;\n}\n\n.paid-media-overview__segmented-tooltip-card {\n  min-width: 280px;\n  max-width: min(320px, calc(100vw - 24px));\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);\n}\n\n.paid-media-overview__segmented-tooltip-title {\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.4;\n  color: #0f172a;\n}\n\n.paid-media-overview__segmented-tooltip-description {\n  font-size: 12px;\n  line-height: 1.45;\n  color: #475569;\n  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n.paid-media-overview__more-filters-panel {\n  position: absolute;\n  inset-inline-end: 0;\n  top: calc(100% + 6px);\n  z-index: 20;\n  width: 288px;\n  border: 1px solid $dt-border;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: $shadow-md;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Arabic: open toward the physical right so the panel stays inside the viewport. */\n[dir=\"rtl\"] .paid-media-overview__header {\n  .paid-media-overview__segmented-tooltip--end {\n    right: auto;\n    left: 0;\n  }\n\n  .paid-media-overview__more-filters-panel {\n    inset-inline-end: auto;\n    inset-inline-start: auto;\n    right: auto;\n    left: 0;\n  }\n}\n\n/* Safety: the dashboard shell hides horizontal overflow; relax it while the panel is open in Arabic. */\n[dir=\"rtl\"] .paid-media-dashboard:has(.paid-media-overview__more-filters--open) {\n  overflow-x: visible;\n}\n\n.paid-media-overview__filter-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__filter-label-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 4px;\n\n  .paid-media-overview__filter-label {\n    margin-bottom: 0;\n  }\n}\n\n.paid-media-overview__filter-row--disabled {\n  .paid-media-overview__filter-label {\n    color: #94a3b8;\n  }\n}\n\n.paid-media-overview__filter-select {\n  width: 100%;\n\n  .sales-product-analytics-dashboard__select-trigger {\n    height: 34px;\n    padding: 0 10px;\n    border: 1px solid $dt-border;\n    border-radius: 6px;\n    background: #ffffff;\n    font-size: 12px;\n    color: $dt-text;\n  }\n}\n\n.paid-media-overview__filter-select--disabled {\n  .sales-product-analytics-dashboard__select-trigger,\n  .sales-product-analytics-dashboard__select-trigger--disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n    background: #f8fafc;\n    color: #64748b;\n    border-color: #e2e8f0;\n  }\n}\n\n.paid-media-overview__filter-select-dropdown {\n  max-height: min(240px, calc(100vh - 120px));\n  overflow-y: auto;\n  scrollbar-color: #cbd5e1 transparent;\n  scrollbar-width: thin;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 999px;\n    background: #cbd5e1;\n  }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);","/* ---------- Partial-data warnings banner ---------- */\n.paid-media-overview__warnings {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  border: 1px solid rgba($dt-warning, 0.4);\n  background: rgba($dt-warning, 0.08);\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n\n.paid-media-overview__warnings-icon {\n  display: inline-flex;\n  color: $dt-warning;\n  margin-top: 1px;\n}\n\n.paid-media-overview__warnings-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.paid-media-overview__warnings-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-warning;\n}\n\n.paid-media-overview__warnings-list {\n  margin: 0;\n  padding-inline-start: 16px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: $dt-text;\n}\n","/* ---------- KPI grid ---------- */\n.paid-media-overview__kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.paid-media-overview__kpi-card {\n  min-height: 140px;\n}\n\n.paid-media-overview__kpi-card.dashboard-kpi-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.05);\n  padding: 18px 20px;\n  min-height: 168px;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__title {\n  color: #667085;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n  letter-spacing: 0.01em;\n  text-transform: none;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__value {\n  color: #101828;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  white-space: normal;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__sublabel,\n.paid-media-overview__kpi-card .dashboard-kpi-card__comparison,\n.paid-media-overview__kpi-card .dashboard-kpi-card__footer,\n.paid-media-overview__kpi-card .dashboard-kpi-card__description {\n  color: #667085;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__change {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  background: #eef4ff;\n  color: #2563eb;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n.paid-media-overview__kpi-card .dashboard-kpi-card__title-row {\n  margin-bottom: 20px;\n}\n\n\n@media (max-width: 1280px) {\n  .paid-media-overview__kpi-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__header {\n    flex-direction: column;\n    align-items: stretch;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n  }\n\n  .paid-media-overview__header-actions {\n    margin-inline-start: 0;\n    align-items: flex-end;\n    width: 100%;\n  }\n\n  .paid-media-overview__header-row {\n    justify-content: flex-end;\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .paid-media-overview__header-row--bottom {\n    flex-wrap: wrap;\n    width: 100%;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 639px) {\n  .paid-media-overview__kpi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .paid-media-overview__header {\n    gap: 6px;\n    padding: 0 0 2px;\n  }\n\n  .paid-media-overview__header-copy {\n    gap: 2px;\n  }\n\n  .paid-media-overview__title {\n    font-size: 24px;\n  }\n\n  .paid-media-overview__subtitle {\n    font-size: 13px;\n  }\n\n  .paid-media-overview__header-actions {\n    width: 100%;\n    align-items: flex-end;\n    gap: 6px;\n    margin-inline-start: 0;\n  }\n\n  .paid-media-overview__header-row:not(.paid-media-overview__header-row--bottom) {\n    width: 100%;\n    max-width: 100%;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: flex-end;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .paid-media-overview__header-row:not(.paid-media-overview__header-row--bottom)::-webkit-scrollbar {\n    display: none;\n  }\n\n  .paid-media-overview__header-row--bottom {\n    flex-direction: row;\n    align-items: center;\n    gap: 6px;\n    width: 100%;\n  }\n\n  .paid-media-overview__segmented,\n  .paid-media-overview__date-range,\n  .paid-media-overview__more-filters-trigger {\n    width: auto;\n    max-width: none;\n    justify-content: flex-end;\n    flex-shrink: 0;\n  }\n\n  .paid-media-overview__segmented {\n    display: inline-flex;\n    min-width: fit-content;\n  }\n\n  .paid-media-overview__segmented-btn {\n    padding: 7px 10px;\n    font-size: 11px;\n  }\n\n  .paid-media-overview__date-range {\n    flex-wrap: nowrap;\n    padding: 6px 8px;\n  }\n\n  .paid-media-overview__date-range input {\n    width: 84px;\n    min-width: 0;\n  }\n\n  .paid-media-overview__more-filters-trigger {\n    padding: 7px 10px;\n  }\n}\n","/* ---------- Shared panel bits ---------- */\n.paid-media-overview__panel-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px 12px;\n  margin-bottom: 12px;\n\n  h3 {\n    margin: 0;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    color: $dt-text;\n  }\n\n  /* Lets the title column wrap instead of being squeezed by the legend. */\n  > div {\n    min-width: 0;\n  }\n}\n\n/* The overview spaces its rows with grid `gap`, so the shared panel's own bottom\n * margin has to go — otherwise two panels in the same row end at different\n * heights (the margin is subtracted from the stretched item). */\n.paid-media-overview__trend-grid > .paid-media-panel,\n.paid-media-overview__two-col-grid > .paid-media-panel,\n.paid-media-overview__comparison-grid > .paid-media-panel,\n.paid-media-overview__insight-stack > .paid-media-panel {\n  margin-bottom: 0;\n}\n\n.paid-media-overview__panel-subtitle {\n  margin: 2px 0 0;\n  font-size: 14px;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__panel-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.paid-media-overview__panel-header-note {\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n  white-space: nowrap;\n}\n\n/* Four platform averages sit two per line so they cannot squeeze the title. */\n.paid-media-overview__legend-inline {\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  justify-content: end;\n  gap: 2px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 767px) {\n  .paid-media-overview__legend-inline {\n    justify-content: start;\n  }\n}\n\n.paid-media-overview__chart-legend-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin: 8px 0 12px;\n  padding: 0;\n  background: transparent;\n  border: 0;\n}\n\n.paid-media-overview__chart-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border-radius: 0;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #475569;\n  background: transparent;\n}\n\n.paid-media-overview__chart-legend-item--purple {\n  color: #8d4fd3;\n}\n\n.paid-media-overview__chart-legend-item--green {\n  color: #5abf8b;\n}\n\n.paid-media-overview__chart-legend-item--mint {\n  color: #94d0b5;\n}\n\n.paid-media-overview__chart-legend-item--meta {\n  color: #2b74e4;\n}\n\n.paid-media-overview__chart-legend-item--google {\n  color: #f6c15f;\n}\n\n.paid-media-overview__chart-legend-item--meta-revenue {\n  color: #5d97ee;\n}\n\n.paid-media-overview__chart-legend-item--google-revenue {\n  color: #f0a84a;\n}\n\n.paid-media-overview__chart-legend-swatch {\n  width: 20px;\n  height: 14px;\n  border-radius: 0;\n  flex-shrink: 0;\n}\n\n.paid-media-overview__chart-legend-swatch--purple {\n  background: #8d4fd3;\n}\n\n.paid-media-overview__chart-legend-swatch--green {\n  background: #5abf8b;\n}\n\n.paid-media-overview__chart-legend-swatch--mint {\n  background: #94d0b5;\n}\n\n.paid-media-overview__chart-legend-swatch--meta {\n  background: #2b74e4;\n}\n\n.paid-media-overview__chart-legend-swatch--google {\n  background: #f6c15f;\n}\n\n.paid-media-overview__chart-legend-swatch--meta-revenue {\n  background: #5d97ee;\n}\n\n.paid-media-overview__chart-legend-swatch--google-revenue {\n  background: #f0a84a;\n}\n\n.paid-media-overview__callout {\n  margin-top: 12px;\n  border: 1px solid $dt-border;\n  background: $dt-bg-light;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: $dt-text-secondary;\n\n  strong {\n    color: $dt-text;\n  }\n}\n\n.paid-media-overview__callout--success {\n  border-color: #c9e5cf;\n  background: #f0f8f2;\n  color: $dt-text;\n\n  strong {\n    color: $dt-success;\n  }\n}\n\n.paid-media-overview__text-success {\n  color: $dt-success;\n}\n\n.paid-media-overview__text-danger {\n  color: $dt-danger;\n}\n\n.paid-media-overview__text-warning {\n  color: $dt-warning;\n}\n\n/* Shown in place of a chart when the series has no rows. */\n.paid-media-overview__chart-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 160px;\n  padding: 16px;\n  border: 1px dashed $dt-border;\n  border-radius: 8px;\n  background: $dt-bg-light;\n  font-size: 13px;\n  color: $dt-text-secondary;\n  text-align: center;\n}\n","/* ---------- Comparison cards ---------- */\n.paid-media-overview__comparison-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n/* The two insight cards carry little content, so they keep their natural height\n * and sit centred in the column: the leftover height is split evenly above and\n * below the pair instead of leaving a gap between them. */\n.paid-media-overview__insight-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n  height: 100%;\n}\n\n// The stack sits beside the (much taller) trend chart. Letting the cards grow to share\n// the column height keeps the row visually flush, instead of centring two fixed-height\n// cards and leaving dead space above and below them.\n.paid-media-overview__insight-stack .paid-media-overview__insight-card {\n  flex: 1 1 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n@media (max-width: 1279px) {\n  .paid-media-overview__comparison-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 639px) {\n  .paid-media-overview__comparison-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.paid-media-overview__platform-card,\n.paid-media-overview__insight-card {\n  padding: 16px;\n}\n\n.paid-media-overview__platform-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.paid-media-overview__platform-card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: $dt-text;\n\n  span:last-child {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n}\n\n.paid-media-overview__platform-card-icon {\n  display: grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  color: #ffffff;\n}\n\n.paid-media-overview__platform-card-tag {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__platform-card-metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px 12px;\n  font-size: 12px;\n}\n\n.paid-media-overview__metric-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__metric-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__platform-card-shares {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.paid-media-overview__insight-card-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.paid-media-overview__insight-card-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__insight-card-icon {\n  color: $dt-text-muted;\n}\n\n.paid-media-overview__insight-card-value {\n  margin-top: 8px;\n  font-size: 20px;\n  font-weight: 700;\n  color: $dt-text;\n}\n\n.paid-media-overview__insight-card-copy {\n  margin: 8px 0 0;\n  font-size: 12px;\n  line-height: 1.6;\n  color: $dt-text-secondary;\n\n  strong {\n    color: $dt-text;\n  }\n}\n\n.paid-media-overview__insight-card-callout {\n  margin-top: 12px;\n  border-radius: 6px;\n  padding: 6px 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.paid-media-overview__insight-card-callout--positive {\n  border: 1px solid #c9e5cf;\n  background: #f0f8f2;\n  color: $dt-success;\n}\n\n.paid-media-overview__insight-card-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 12px;\n  margin-top: 12px;\n  font-size: 11px;\n  color: $dt-text-secondary;\n\n  strong {\n    color: $dt-text;\n  }\n}\n\n","/* ---------- Platform palette ----------\n * Slugs match `OverviewPlatformDescriptor.slug`; the fill colours match the\n * chart series colours in the same registry.\n */\n$paid-media-platform-fills: (\n  \"meta\": #2b74e4,\n  \"google\": #f6c15f,\n  \"tiktok\": #ff3b5c,\n  \"snapchat\": #0ea5a4,\n);\n\n/* Darkened for text and small dots, where the chart fill is too light to read. */\n$paid-media-platform-inks: (\n  \"meta\": #2b74e4,\n  \"google\": #c18a2f,\n  \"tiktok\": #e11d48,\n  \"snapchat\": #0f766e,\n);\n\n@each $slug, $color in $paid-media-platform-fills {\n  .paid-media-overview__share-bar-fill--#{$slug}-ads {\n    background-color: $color;\n  }\n\n  .paid-media-overview__platform-dot-swatch--#{$slug} {\n    background-color: $color;\n  }\n\n  .paid-media-overview__drawer-platform-tag--#{$slug} {\n    background-color: $color;\n  }\n\n  .paid-media-overview__funnel[data-platform=\"#{$slug}\"] {\n    .paid-media-overview__funnel-dot,\n    .paid-media-overview__funnel-bar {\n      background-color: $color;\n    }\n  }\n}\n\n@each $slug, $ink in $paid-media-platform-inks {\n  .paid-media-overview__index-row-dot--#{$slug} {\n    background-color: $ink;\n  }\n\n  .paid-media-overview__legend-inline-item--#{$slug} {\n    color: $ink;\n  }\n\n  .paid-media-overview__chart-tooltip-heading--#{$slug} {\n    color: $ink;\n  }\n}\n\n/* Card badges keep each network's own brand colour. */\n.paid-media-overview__platform-card-icon {\n  &--meta {\n    background-color: map-get($paid-media-platform-fills, \"meta\");\n  }\n\n  &--google {\n    background-color: map-get($paid-media-platform-fills, \"google\");\n  }\n\n  &--tiktok {\n    background-color: #010101;\n  }\n\n  &--snapchat {\n    background-color: #fffc00;\n    color: #111827;\n  }\n}\n\n.paid-media-overview__platform-dot-swatch--unknown,\n.paid-media-overview__drawer-platform-tag--unknown {\n  background-color: $dt-text-muted;\n}\n","/* ---------- Share bar ---------- */\n.paid-media-overview__share-bar-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 4px;\n  font-size: 12px;\n}\n\n.paid-media-overview__share-bar-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__share-bar-value {\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__share-bar-track {\n  height: 8px;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 999px;\n  background: $dt-border;\n}\n\n.paid-media-overview__share-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  /* Live percentage supplied by OverviewShareBar; 0% until it is set. */\n  width: var(--paid-media-share-bar-value, 0%);\n}\n","/* ---------- Status badge / platform dot ---------- */\n.paid-media-overview__status-badge {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 6px;\n  border: 1px solid;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.paid-media-overview__status-badge .definition-tooltip {\n  position: absolute;\n  inset: 0;\n  display: block;\n}\n\n.paid-media-overview__status-badge .definition-tooltip__trigger {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  min-height: 0;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  opacity: 0;\n  cursor: help;\n}\n\n.paid-media-overview__platform-dot {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.paid-media-overview__platform-dot-swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n}\n\n\n/*\n * Status badge palette. Modifier slugs are produced by `overviewStatusModifier`,\n * so the badge component ships class names only and carries no inline styles.\n */\n$paid-media-status-colors: (\n  \"scale-winner\": $dt-success,\n  \"efficiency-winner\": $dt-primary,\n  \"growth-opportunity\": $dt-purple,\n  \"stable\": $dt-text-secondary,\n  \"high-spend-low-return\": $dt-danger,\n  \"needs-review\": $dt-warning,\n  \"low-priority\": $dt-text-secondary,\n  \"unknown\": $dt-text-secondary,\n);\n\n@each $name, $color in $paid-media-status-colors {\n  .paid-media-overview__status-badge--#{$name} {\n    color: $color;\n    border-color: $color;\n    background-color: rgba($color, 0.07);\n  }\n}\n","/* ---------- Trend + contribution row ---------- */\n.paid-media-overview__trend-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 7fr) minmax(280px, 3fr);\n  gap: 12px;\n}\n\n@media (max-width: 1279px) {\n  .paid-media-overview__trend-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.paid-media-overview__trend-metric-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  border-bottom: 1px solid $dt-border;\n  margin-bottom: 12px;\n}\n\n.paid-media-overview__trend-metric-tab {\n  display: flex;\n  align-items: center;\n}\n\n.paid-media-overview__trend-metric-btn {\n  position: relative;\n  border: 0;\n  background: transparent;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text-secondary;\n  cursor: pointer;\n\n  &:hover {\n    color: $dt-text;\n  }\n}\n\n.paid-media-overview__trend-metric-btn--active {\n  color: $dt-primary;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    left: 4px;\n    right: 4px;\n    bottom: -1px;\n    height: 2px;\n    border-radius: 2px 2px 0 0;\n    background: $dt-primary;\n  }\n}\n\n.paid-media-overview__chart {\n  width: 100%;\n}\n\n.paid-media-overview__chart--trend {\n  height: 320px;\n}\n\n.paid-media-overview__chart--md {\n  height: 280px;\n}\n\n.paid-media-overview__chart--sm {\n  height: 260px;\n}\n\n.paid-media-overview__chart-tooltip {\n  border: 1px solid $dt-border;\n  border-inline-start: 4px solid $dt-primary;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 10px 14px 10px 12px;\n  font-size: 11px;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);\n}\n\n.paid-media-overview__chart-tooltip-title {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__chart-tooltip-columns {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 4px 16px;\n}\n\n.paid-media-overview__chart-tooltip-columns--quad {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__chart-tooltip-columns--quad {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.paid-media-overview__chart-tooltip-heading {\n  margin-bottom: 2px;\n  font-weight: 600;\n}\n\n.paid-media-overview__chart-tooltip-footer {\n  margin-top: 8px;\n  padding-top: 6px;\n  border-top: 1px solid $dt-border;\n  color: $dt-text-secondary;\n\n  strong {\n    color: $dt-text;\n  }\n}\n\n.paid-media-overview__contribution-rows {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px 24px;\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__contribution-rows {\n    grid-template-columns: 1fr;\n  }\n}\n\n.paid-media-overview__contribution-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.paid-media-overview__contribution-row-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n}\n","/* ---------- Two-column rows ---------- */\n.paid-media-overview__two-col-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__two-col-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ---------- Funnel ---------- */\n.paid-media-overview__funnel-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px 24px;\n}\n\n@media (max-width: 1279px) {\n  .paid-media-overview__funnel-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 639px) {\n  .paid-media-overview__funnel-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.paid-media-overview__funnel-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__funnel-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n}\n\n.paid-media-overview__funnel-stages {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.paid-media-overview__funnel-stage-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11px;\n  color: $dt-text-secondary;\n  padding-bottom: 5px;\n\n  span:first-child {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n  }\n}\n\n.paid-media-overview__funnel-stage-value {\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__funnel-bar {\n  height: 24px;\n  border-radius: 6px;\n  opacity: 0.85;\n}\n\n.paid-media-overview__funnel-footer {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 12px;\n  border: 1px solid $dt-border;\n  background: $dt-bg-light;\n  border-radius: 6px;\n  padding: 8px;\n  font-size: 11px;\n}\n\n.paid-media-overview__funnel-footer-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  text-transform: uppercase;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__funnel-footer-value {\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__funnel-bar-progress-bar-center {\n  justify-content: center;\n  display: flex;\n}\n\n\n.paid-media-overview__funnel-bar {\n  &[data-width=\"full\"] {\n    width: 100%;\n  }\n  &[data-width=\"mid\"] {\n    width: 68%;\n  }\n  &[data-width=\"low\"] {\n    width: 32%;\n  }\n}\n","/* ---------- Investment efficiency ---------- */\n.paid-media-overview__investment-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 1023px) {\n  .paid-media-overview__investment-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.paid-media-overview__index-panel {\n  border: 1px solid $dt-border;\n  background: $dt-bg-light;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.paid-media-overview__index-panel-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__index-panel-subtitle {\n  margin-top: 4px;\n  font-size: 10px;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__index-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.paid-media-overview__index-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid $dt-border;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 6px 8px;\n}\n\n.paid-media-overview__index-row-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n}\n\n\n.paid-media-overview__index-row-value {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.paid-media-overview__index-panel-footnote {\n  margin-top: 12px;\n  font-size: 11px;\n  color: $dt-text-secondary;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.paid-media-overview__index-row-dot {\n  &--meta {\n    background-color: #2b74e4; \n  }\n  &--google {\n    background-color: #c18a2f;\n  }\n}\n\n.paid-media-overview__share-bar {\n  &--spend path {\n    fill: #2b74e4;\n  }\n  &--revenue path {\n    fill: #8d4fd3;\n  }\n}\n\n.paid-media-overview__share-bar-label {\n  font-size: 11px;\n  fill: #1a1a1a;\n  font-weight: 600;\n}\n","/* ---------- Quadrant chart ---------- */\n.paid-media-overview__quadrant-chart {\n  position: relative;\n  height: 360px;\n  width: 100%;\n}\n\n.paid-media-overview__quadrant-labels {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-text-muted;\n}\n\n.paid-media-overview__quadrant-label {\n  position: absolute;\n}\n\n/*\n * The `tl`/`tr`/`bl`/`br` modifiers name the quadrant in reading order, not in physical sides:\n * the scatter's spend axis counts from the inline start, so in Arabic it counts from the right and\n * these labels have to follow it. Insets are logical for that reason — the wider start inset also\n * clears the value axis, which moves to the right edge with the axis (see `usePaidMediaChartRtl`).\n */\n.paid-media-overview__quadrant-label--tl {\n  inset-inline-start: 56px;\n  top: -8px;\n}\n\n.paid-media-overview__quadrant-label--tr {\n  inset-inline-end: 16px;\n  top: -8px;\n}\n\n.paid-media-overview__quadrant-label--bl {\n  inset-inline-start: 56px;\n  bottom: 18px;\n}\n\n.paid-media-overview__quadrant-label--br {\n  inset-inline-end: 16px;\n  bottom: 18px;\n}\n\n.paid-media-overview__quadrant-tooltip {\n  max-width: 260px;\n  border: 1px solid $dt-border;\n  border-inline-start: 4px solid $dt-primary;\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 10px 14px 10px 12px;\n  font-size: 11px;\n  line-height: 1.6;\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.12);\n}\n\n.paid-media-overview__quadrant-tooltip-title {\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__quadrant-tooltip-body {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  color: $dt-text;\n}\n\n.paid-media-overview__quadrant-tooltip-classification {\n  margin-top: 6px;\n  font-weight: 600;\n  color: $dt-primary;\n}\n\n.paid-media-overview__quadrant-tooltip-reason {\n  margin-top: 4px;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__quadrant-tooltip-hint {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid $dt-border;\n  color: $dt-primary;\n  font-weight: 500;\n}\n","/* ---------- Revenue validation ---------- */\n.paid-media-overview__variance-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.paid-media-overview__variance-box {\n  border: 1px solid $dt-border;\n  background: $dt-bg-light;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.paid-media-overview__variance-box-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__variance-box-metrics {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.paid-media-overview__variance-box-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 10px;\n  text-transform: uppercase;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__variance-box-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: $dt-text;\n}\n\n/* Shown in place of the store columns when no store is connected. */\n.paid-media-overview__confidence-footnote {\n  margin-top: 16px;\n  font-size: 11px;\n  line-height: 1.6;\n  color: $dt-text-secondary;\n}\n\n/* ---------- Attribution confidence ---------- */\n.paid-media-overview__confidence-score {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 20px 16px;\n  margin-bottom: 20px;\n  border: 1px solid $dt-border;\n  border-radius: 10px;\n  background: $dt-bg-light;\n  text-align: center;\n}\n\n.paid-media-overview__confidence-score-value {\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #16a34a;\n}\n\n.paid-media-overview__confidence-score-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #16a34a;\n}\n\n.paid-media-overview__confidence-components {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n\n.paid-media-overview-platform-and-store {\n   margin: 5px 10px 5px 0 !important;\n}\n.paid-media-daily-spend-revenue-trend {\n   margin: 5px 10px 5px -10 !important;\n}\n\n.platform-reported-bar {\n  fill: #8d4fd3 !important;\n}\n.store-gross-bar {\n  fill: #5abf8b !important;\n}\n.store-net-bar {\n  fill: #94d0b5 !important;\n}\n\n.paid-media-overview__share-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n\n  &--confidence-green {\n    background-color: #5abf8b;\n  }\n\n  &--confidence-blue {\n    background-color: #2b74e4;\n  }\n\n  &--confidence-purple {\n    background-color: #8d4fd3;\n  }\n\n  &--confidence-orange {\n    background-color: #f6c15f;\n  }\n}\n\n.benchmark-reference-label {\n  fill: #8d4fd3;\n  font-size: 14px;\n  font-weight: 500;\n}\n","/* ---------- Campaign leaderboard ---------- */\n.paid-media-overview__leaderboard {\n  padding: 0;\n  overflow: hidden;\n\n  table {\n    width: max-content;\n    min-width: 100%;\n    table-layout: auto;\n  }\n\n  table,\n  th,\n  td {\n    white-space: nowrap;\n  }\n\n  th,\n  td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  th:last-child,\n  td:last-child {\n    width: 1%;\n    white-space: nowrap;\n  }\n}\n\n.paid-media-overview__leaderboard-header {\n  padding: 16px;\n}\n\n.paid-media-overview__leaderboard-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: end;\n  gap: 12px;\n}\n\n.paid-media-overview__leaderboard-platform-tabs {\n  display: flex;\n  gap: 2px;\n  border: 1px solid $dt-border;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n// The search box is styled in `_drawer.scss`, which is imported after this file — an\n// earlier duplicate block here was dead weight and drifted out of sync with it.\n\n.paid-media-overview__export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid $dt-border;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: $dt-primary;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.paid-media-overview__leaderboard-th {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.paid-media-overview__leaderboard-th--right {\n  justify-content: flex-end;\n}\n\n.paid-media-overview__leaderboard-cell--right {\n  text-align: end;\n}\n\n.paid-media-overview__leaderboard-cell--strong {\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__leaderboard-cell--status {\n  white-space: nowrap;\n}\n\n.paid-media-overview__leaderboard-row-link {\n  display: inline-block;\n  max-width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  font: inherit;\n  font-weight: 600;\n  color: $dt-text;\n  cursor: pointer;\n  text-align: start;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:hover {\n    color: $dt-primary;\n    text-decoration: underline;\n  }\n}\n\n.paid-media-overview__cell-strong {\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__popover {\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__popover::-webkit-scrollbar {\n  display: none;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__text,\n.paid-media-overview__leaderboard .definition-tooltip__formula,\n.paid-media-overview__leaderboard .definition-tooltip__note {\n  margin: 0;\n  line-height: 1.5;\n  white-space: normal;\n}\n\n.paid-media-overview__leaderboard .definition-tooltip__formula-box {\n  margin-top: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n}\n\n.paid-media-overview__leaderboard-empty {\n  margin: 0;\n  padding: 32px 16px;\n  font-size: 13px;\n  color: $dt-text-secondary;\n  text-align: center;\n}\n\n@media (min-width: 965px) and (max-width: 1333px) {\n  .paid-media-overview__leaderboard-filters {\n    justify-content: end;\n  }\n}","/* ---------- Drawer ---------- */\n.paid-media-overview__drawer-title {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ant-drawer-right .ant-drawer-header .ant-drawer-header-title {\n  flex-direction: row-reverse;\n}\n\n.paid-media-overview__drawer-subtitle {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 400;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__drawer-platform-tag {\n  border-radius: 6px;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.paid-media-overview__drawer-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.paid-media-overview__campaign-drawer {\n  .ant-drawer-body {\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n  }\n\n  .paid-media-overview__drawer-body {\n    flex: 1;\n    min-height: 0;\n  }\n\n  .paid-media-overview__drawer-chart-card {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n  }\n\n  /* Chart no longer has a fixed height: it fills the card and never pushes it. */\n  .paid-media-overview__chart--sm {\n    flex: 1;\n    height: auto;\n    min-height: 180px;\n    min-width: 0;\n  }\n}\n\n.paid-media-overview__drawer-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.paid-media-overview__mini-kpi {\n  border: 1px solid $dt-border;\n  background: $dt-bg-light;\n  border-radius: 6px;\n  padding: 8px;\n}\n\n.paid-media-overview__mini-kpi-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $dt-text-secondary;\n}\n\n.paid-media-overview__mini-kpi-value {\n  font-size: 14px;\n  font-weight: 700;\n  color: $dt-text;\n}\n\n.paid-media-overview__drawer-chart-card {\n  border: 1px solid $dt-border;\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.paid-media-overview__drawer-chart-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n}\n\n.paid-media-overview__drawer-insight {\n  border: 1px solid #bfd4f2;\n  background: #eaf2fd;\n  border-radius: 6px;\n  padding: 12px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: $dt-text;\n\n  strong {\n    color: $dt-primary;\n  }\n}\n\n.paid-media-overview__drawer-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  padding-top: 8px;\n}\n\n.paid-media-overview__drawer-close {\n  border: 1px solid $dt-border;\n  background: #ffffff;\n  border-radius: 6px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n  cursor: pointer;\n\n  &:hover {\n    border-color: $dt-primary;\n  }\n}\n\n// Filters and Tabs\n\n/* Search box */\n.paid-media-overview__leaderboard-search {\n  height: 48px;\n  min-width: 220px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 14px;\n  background: #ffffff;\n  border: 1px solid #e2e2e6;\n  border-radius: 10px;\n  box-sizing: border-box;\n}\n\n.paid-media-overview__leaderboard-search:hover,\n.paid-media-overview__leaderboard-search:focus-within {\n  border-color: #2b74e4;\n}\n\n// `input` is styled globally (Auth.scss gives every input a border/radius/padding), and\n// that rule loads after this one — so the chrome has to be cleared at higher specificity,\n// otherwise the input paints its own box inside the search wrapper's box.\n.paid-media-overview__leaderboard-search .paid-media-overview__leaderboard-search-input,\n.paid-media-overview__leaderboard-search input {\n  border: none;\n  border-radius: 0;\n  outline: none;\n  padding: 0;\n  font-size: 14px;\n  color: #1a1a1a;\n  background: transparent;\n  width: 100%;\n}\n\n.paid-media-overview__leaderboard-search input::placeholder {\n  color: #9a9a9f;\n}\n\n/* Dropdowns */\n.paid-media-overview__leaderboard-filter-dropdown {\n  height: 48px;\n  box-sizing: border-box;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown .ant-select-selector,\n.paid-media-overview__leaderboard-filter-dropdown.ant-select .ant-select-selector {\n  height: 38px !important;\n  border-radius: 10px !important;\n  padding: 0 14px !important;\n  display: flex;\n  align-items: center;\n  background-color: #ffffff !important;\n  border: 1px solid #e2e2e6 !important;\n  box-sizing: border-box;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown .ant-select-selection-item {\n  font-size: 14px;\n  line-height: 36px;\n  color: #2b74e4;\n  font-weight: 500;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown:hover .ant-select-selector {\n  border-color: #2b74e4 !important;\n  background-color: #ffffff !important;\n}\n\n.paid-media-overview__leaderboard-filter-dropdown.ant-select-focused .ant-select-selector,\n.paid-media-overview__leaderboard-filter-dropdown.ant-select-open .ant-select-selector {\n  border-color: #2b74e4 !important;\n  background-color: #ffffff !important;\n  box-shadow: 0 0 0 2px rgba(43, 116, 228, 0.12) !important;\n}","/* ---------- Level tabs (Campaigns / Ad sets / Ads) ---------- */\n.paid-media-overview__level-tabs {\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  background: #eef1f6;\n  border-radius: 12px;\n  padding: 6px;\n  margin-bottom: 12px;\n}\n\n.paid-media-overview__level-tab {\n  border: 0;\n  background: transparent;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover {\n    color: #1a1a2e;\n  }\n}\n\n.paid-media-overview__level-tab--active {\n  background: #ffffff;\n  color: #1a1a2e;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n}\n\n.paid-media-overview__leaderboard-toprow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.paid-media-overview__panel-header-titles {\n  min-width: 0;\n\n  h3 {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: #101828;\n  }\n}\n\n.paid-media-overview__export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 48px;\n  border: 1px solid $dt-border;\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 0 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: $dt-text;\n  cursor: pointer;\n  box-sizing: border-box;\n  flex-shrink: 0;\n\n  &:hover {\n    border-color: $dt-primary;\n  }\n}\n\n// Paid Media campaign-leaderboard-article css\n.campaign-leaderboard-article {\n  padding: 0px 0px !important;\n}\n\n.paid-media-overview__leaderboard-table-wrap {\n  .dashboard-data-table-card {\n    border: 0;\n    border-top: 1px solid #e5e5e5;\n    border-radius: 0;\n    box-shadow: none;\n    background: transparent;\n  }\n}\n\n// spend revenue over time tabs daily, weekly and monthly css\n.paid-media-overview__granularity-segmented {\n  .paid-media-overview__segmented {\n    // e.g. override container styling\n    border-color: #d0d5dd;\n    background: #eef1f6;\n  }\n\n  .paid-media-overview__segmented-btn {\n    // e.g. override button styling\n    border: 0;\n    border-radius: 7px;\n    background: transparent;\n    color: #64748b;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1;\n    min-width: 48px;\n    height: 28px;\n    padding: 0 12px;\n    cursor: pointer;\n\n    &:hover {\n      background: #eef1f6;\n    }\n  }\n\n  .paid-media-overview__segmented-btn--active {\n    // e.g. override active statete;\n    background: #ffffff;\n    color: #000000;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);\n    &:hover {\n  background: white;\n  }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
